import moment from "moment";
import { globals, page as pageIndex } from "../../globals";
import { logOut } from "./auth";
import { formatDate } from "./formatDate";
import {
  GET_CLIENTS_FAILURE,
  GET_CLIENT_SUBJECT_INFO_FAILURE,
  GET_GROUPING_FAILURE,
  GET_SUBJECTS_FAILURE,
  POST_CLIENT_SUBJECT_TAG_FAILURE,
  POST_CLIENT_SUBJECT_TAG_SUCCESS,
} from "./groupings";
import { populateSortAndSearchParams } from "./helpers";
import { showModal } from "./modal";
import {
  addInitialValue,
  clearHistory,
  deleteInitialValueAt,
  saveInitialValues,
  setUpdatedValues,
} from "./undo";
import { UPDATE_DATA, actionHandler } from "./updateData";
import { returnRegions } from './regions';
import {
  GET_COUNTRIES_FETCHED,
  GET_COUNTRY_REGIONS_FETCHED,
  GET_ALL_REGIONS_FETCHED } from './regions';

import { constants as regulationConstants } from "../../components/AddRegulation/constants";

// ------------------------------------
// Constants
// ------------------------------------
export const REGS_TRACK_INT_OPEN_RECORD_START =
  "REGS_TRACK_INT_OPEN_RECORD_START";
export const REFRESH_REGS_TRACK_RECORDS = "REFRESH_REGS_TRACK_RECORDS";
export const UPDATE_REGS_TRACK_REVIEW_DATA = "UPDATE_REGS_TRACK_REVIEW_DATA";
export const GET_REGS_TRACK_QUERIES_LIST_START =
  "GET_REGS_TRACK_QUERIES_LIST_START";
export const GET_REGS_TRACK_INT_QUERY_DATA_START =
  "GET_REGS_TRACK_INT_QUERY_DATA_START";
export const GET_REGS_TRACK_INT_QUERY_DATA_SUCCESS =
  "GET_REGS_TRACK_INT_QUERY_DATA_SUCCESS";
export const GET_REGS_TRACK_INT_QUERY_DATA_FAILURE =
  "GET_REGS_TRACK_INT_QUERY_DATA_FAILURE";
export const GET_REGS_TRACK_TEAM_REVIEW_DATA_START =
  "GET_REGS_TRACK_TEAM_REVIEW_DATA_START";
export const GET_REGS_TRACK_TEAM_REVIEW_DATA_SUCCESS =
  "GET_REGS_TRACK_TEAM_REVIEW_DATA_SUCCESS";
export const GET_REGS_TRACK_TEAM_REVIEW_DATA_FAILURE =
  "GET_REGS_TRACK_TEAM_REVIEW_DATA_FAILURE";
export const SET_REGS_TRACK_TEAMS_REVIEW_DATA_START =
  "SET_REGS_TRACK_TEAMS_REVIEW_DATA_START";
export const SET_REGS_TRACK_TEAMS_REVIEW_DATA_SUCCESS =
  "SET_REGS_TRACK_TEAMS_REVIEW_DATA_SUCCESS";
export const SET_REGS_TRACK_TEAMS_REVIEW_DATA_FAILURE =
  "SET_REGS_TRACK_TEAMS_REVIEW_DATA_FAILURE";
export const POST_REGS_TRACK_DATA_START = "POST_REGS_TRACK_DATA_START";
export const POST_REGS_TRACK_DATA_SUCCESS = "POST_REGS_TRACK_DATA_SUCCESS";
export const POST_REGS_TRACK_DATA_FAILURE = "POST_REGS_TRACK_DATA_FAILURE";
export const PUT_REGS_INFO_START = "PUT_REGS_INFO_START";
export const PUT_REGS_INFO_SUCCESS = "PUT_REGS_INFO_SUCCESS";
export const PUT_REGS_INFO_FAILURE = "PUT_REGS_INFO_FAILURE";
export const PUT_CLIENT_ACTION_START = "PUT_CLIENT_ACTION_START";
export const PUT_CLIENT_ACTION_SUCCESS = "PUT_CLIENT_ACTION_SUCCESS";
export const PUT_CLIENT_ACTION_FAILURE = "PUT_CLIENT_ACTION_FAILURE";
export const PUT_CLIENT_ACTION_COMMENT_START =
  "PUT_CLIENT_ACTION_COMMENT_START";
export const PUT_CLIENT_ACTION_COMMENT_SUCCESS =
  "PUT_CLIENT_ACTION_COMMENT_SUCCESS";
export const PUT_CLIENT_ACTION_COMMENT_FAILURE =
  "PUT_CLIENT_ACTION_COMMENT_FAILURE";

export const UPDATE_REGS_INFO_URLS = "UPDATE_REGS_INFO_URLS";

export const GET_REGS_TRACK_BASE_START = "GET_REGS_TRACK_BASE_START";
export const GET_REGS_TRACK_BASE_SUCCESS = "GET_REGS_TRACK_BASE_SUCCESS";
export const GET_REGS_TRACK_BASE_FAILURE = "GET_REGS_TRACK_BASE_FAILURE";

export const GET_REGS_TRACK_CLIENTSUBJECT_START = "GET_REGS_TRACK_CLIENTSUBJECT_START";
export const GET_REGS_TRACK_CLIENTSUBJECT_SUCCESS = "GET_REGS_TRACK_CLIENTSUBJECT_SUCCESS";
export const GET_REGS_TRACK_CLIENTSUBJECT_FAILURE = "GET_REGS_TRACK_CLIENTSUBJECT_FAILURE";

export const GET_REGS_TRACK_IDS_START = "GET_REGS_TRACK_IDS_START";
export const GET_REGS_TRACK_IDS_SUCCESS = "GET_REGS_TRACK_IDS_SUCCESS";
export const GET_REGS_TRACK_IDS_FAILURE = "GET_REGS_TRACK_IDS_FAILURE";
export const GET_REGS_TRACK_KEYWORDS_START = "GET_REGS_TRACK_KEYWORDS_START";
export const GET_REGS_TRACK_KEYWORDS_SUCCESS =
  "GET_REGS_TRACK_KEYWORDS_SUCCESS";
export const GET_REGS_TRACK_KEYWORDS_FAILURE =
  "GET_REGS_TRACK_KEYWORDS_FAILURE";
export const GET_REGS_TRACK_CLIENT_SUBJECTS_START =
  "GET_REGS_TRACK_CLIENT_SUBJECTS_START";
export const GET_REGS_TRACK_CLIENT_SUBJECTS_SUCCESS =
  "GET_REGS_TRACK_CLIENT_SUBJECTS_SUCCESS";
export const GET_REGS_TRACK_CLIENT_SUBJECTS_FAILURE =
  "GET_REGS_TRACK_CLIENT_SUBJECTS_FAILURE";
export const GET_REGS_TRACK_REGS_INFO_TYPE_START =
  "GET_REGS_TRACK_REGS_INFO_TYPE_START";
export const GET_REGS_TRACK_REGS_INFO_TYPE_SUCCESS =
  "GET_REGS_TRACK_REGS_INFO_TYPE_SUCCESS";
export const GET_REGS_TRACK_REGS_INFO_TYPE_FAILURE =
  "GET_REGS_TRACK_REGS_INFO_TYPE_FAILURE";
export const GET_REGS_TRACK_LOAD_OPTIONS_START =
  "GET_REGS_TRACK_LOAD_OPTIONS_START";
export const GET_REGS_TRACK_LOAD_OPTIONS_FAILURE =
  "GET_REGS_TRACK_LOAD_OPTIONS_FAILURE";
export const CLEAR_REGS_TRACK_FIELD_FOR_NO_RESULTS =
  "CLEAR_REGS_TRACK_FIELD_FOR_NO_RESULTS";
export const RETURN_REGS_TRACK_INITIAL_STATE =
  "RETURN_REGS_TRACK_INITIAL_STATE";
export const OPEN_REGS_TRACK_RECORD_SUCCESS =
  "OPEN_REGS_TRACK_RECORD_SUCCESS";
export const SET_REGS_TRACK_ID_REVIEWED_START =
  "SET_REGS_TRACK_ID_REVIEWED_START";
export const SET_REGS_TRACK_ID_REVIEWED_FAILURE =
  "SET_REGS_TRACK_ID_REVIEWED_FAILURE";
export const SET_REGS_TRACK_ID_REVIEWED_SUCCESS =
  "SET_REGS_TRACK_ID_REVIEWED_SUCCESS";
export const GET_REGS_TRACK_HIGHLIGHTED_DOC_START =
  "GET_REGS_TRACK_HIGHLIGHTED_DOC_START";
export const GET_REGS_TRACK_HIGHLIGHTED_DOC_FAILURE =
  "GET_REGS_TRACK_HIGHLIGHTED_DOC_FAILURE";
export const GET_REGS_TRACK_HIGHLIGHTED_DOC_SUCCESS =
  "GET_REGS_TRACK_HIGHLIGHTED_DOC_SUCCESS";
export const GET_REGS_TRACK_INITIAL_DATA_START =
  "GET_REGS_TRACK_INITIAL_DATA_START";
export const GET_REGS_TRACK_INITIAL_DATA_COMPLETE =
  "GET_REGS_TRACK_INITIAL_DATA_COMPLETE";
export const GET_QC_KEYWORD_MISSING_START = "GET_QC_KEYWORD_MISSING_START";
export const GET_QC_KEYWORD_MISSING_SUCCESS = "GET_QC_KEYWORD_MISSING_SUCCESS";
export const GET_QC_KEYWORD_MISSING_FAILURE = "GET_QC_KEYWORD_MISSING_FAILURE";
export const GET_QC_KEYWORD_REVIEW_START = "GET_QC_KEYWORD_REVIEW_START";
export const GET_QC_KEYWORD_REVIEW_SUCCESS = "GET_QC_KEYWORD_REVIEW_SUCCESS";
export const GET_QC_KEYWORD_REVIEW_FAILURE = "GET_QC_KEYWORD_REVIEW_FAILURE";
export const GET_REGS_TRACK_SUBJECT_GROUP_LIST_START =
  "GET_REGS_TRACK_SUBJECT_GROUP_LIST_START";
export const GET_REGS_TRACK_SUBJECT_GROUP_LIST_FAILURE =
  "GET_REGS_TRACK_SUBJECT_GROUP_LIST_FAILURE";
export const GET_REGS_TRACK_SUBJECT_GROUP_LIST_SUCCESS =
  "GET_REGS_TRACK_SUBJECT_GROUP_LIST_SUCCESS";
export const SET_QC_KEYWORD_REVIEW_START = "SET_QC_KEYWORD_REVIEW_START";
export const SET_QC_KEYWORD_REVIEW_FAILURE = "SET_QC_KEYWORD_REVIEW_FAILURE";
export const SET_QC_KEYWORD_REVIEW_SUCCESS = "SET_QC_KEYWORD_REVIEW_SUCCESS";
export const FLIP_REGS_INFO_RECORD_LOCK_LOAD_DATE =
  "FLIP_REGS_INFO_RECORD_LOCK_LOAD_DATE";
export const DELETE_REGS_INFO_DOC_START = "DELETE_REGS_INFO_DOC_START";
export const DELETE_REGS_INFO_DOC_SUCCESS = "DELETE_REGS_INFO_DOC_SUCCESS";
export const DELETE_REGS_INFO_DOC_FAILURE = "DELETE_REGS_INFO_DOC_FAILURE";
export const DELETE_REGS_INFO_RECORD_START = "DELETE_REGS_INFO_RECORD_START";
export const DELETE_REGS_INFO_RECORD_SUCCESS = "DELETE_REGS_INFO_RECORD_SUCCESS";
export const DELETE_REGS_INFO_RECORD_FAILURE = "DELETE_REGS_INFO_RECORD_FAILURE";
export const DELETE_REGS_INFO_HISTORY_START = "DELETE_REGS_INFO_HISTORY_START";
export const DELETE_REGS_INFO_HISTORY_SUCCESS = "DELETE_REGS_INFO_HISTORY_SUCCESS";
export const DELETE_REGS_INFO_HISTORY_FAILURE = "DELETE_REGS_INFO_HISTORY_FAILURE";

export const SET_RUNRULES_TRUE = "SET_RUNRULES_TRUE";
export const SET_RUNRULES_FALSE = "SET_RUNRULES_FALSE";

export const ADD_NEW_REGS_INFO_URL_RECORD = "ADD_NEW_REGS_INFO_URL_RECORD";

export const ADD_NEW_REGS_INFO_CITATION_RECORD = "ADD_NEW_REGS_INFO_CITATION_RECORD";

export const ADD_NEW_REGS_INFO_HISTORYACTION_RECORD = "ADD_NEW_REGS_INFO_HISTORYACTION_RECORD";

export const ADD_NEW_REGS_INFO_AGENCY_RECORD = "ADD_NEW_REGS_INFO_AGENCY_RECORD";

export const ADD_REGS_INFO_DOC_START = "ADD_REGS_INFO_DOC_START";
export const ADD_REGS_INFO_DOC_SUCCESS = "ADD_REGS_INFO_DOC_SUCCESS";
export const ADD_REGS_INFO_DOC_FAILURE = "ADD_REGS_INFO_DOC_FAILURE";

// export const GET_ALL_REGIONS_FETCHED = "GET_ALL_REGIONS_FETCHED"

export const ADD_NEW_HISTORY_ACTION_RECORD = "ADD_NEW_HISTORY_ACTION_RECORD";

export const ADD_REGS_INFO_HISTORY_ACTION_START = "ADD_REGS_INFO_HISTORY_ACTION_START";
export const ADD_REGS_INFO_HISTORY_ACTION_SUCCESS = "ADD_REGS_INFO_HISTORY_ACTION_SUCCESS";
export const ADD_REGS_INFO_HISTORY_ACTION_FAILURE = "ADD_REGS_INFO_HISTORY_ACTION_FAILURE";

export const DELETE_REGS_INFO_CLIENT_SUBJECT_TAG_START =
  "DELETE_REGS_INFO_CLIENT_SUBJECT_TAG_START";
export const DELETE_REGS_INFO_CLIENT_SUBJECT_TAG_SUCCESS =
  "DELETE_REGS_INFO_CLIENT_SUBJECT_TAG_SUCCESS";
export const DELETE_REGS_INFO_CLIENT_SUBJECT_TAG_FAILURE =
  "DELETE_REGS_INFO_CLIENT_SUBJECT_TAG_FAILURE";
export const PUT_REGS_INFO_CLIENT_SUBJECT_TAG_START =
  "PUT_REGS_INFO_CLIENT_SUBJECT_TAG_START";
export const PUT_REGS_INFO_CLIENT_SUBJECT_TAG_SUCCESS =
  "PUT_REGS_INFO_CLIENT_SUBJECT_TAG_SUCCESS";
export const PUT_REGS_INFO_CLIENT_SUBJECT_TAG_FAILURE =
  "PUT_REGS_INFO_CLIENT_SUBJECT_TAG_FAILURE";


// SiteURLs
export const PUT_REGS_TRACK_INT_URL_START = "PUT_REGS_TRACK_INT_URL_START";
export const PUT_REGS_TRACK_INT_URL_SUCCESS = "PUT_REGS_TRACK_INT_URL_SUCCESS";
export const PUT_REGS_TRACK_INT_URL_FAILURE = "PUT_REGS_TRACK_INT_URL_FAILURE";

export const POST_REGS_TRACK_INT_URL_START = "POST_REGS_TRACK_INT_URL_START";
export const POST_REGS_TRACK_INT_URL_SUCCESS = "POST_REGS_TRACK_INT_URL_SUCCESS";
export const POST_REGS_TRACK_INT_URL_FAILURE = "POST_REGS_TRACK_INT_URL_FAILURE";

export const DELETE_REGS_TRACK_INT_URL_START = "DELETE_REGS_TRACK_INT_URL_START";
export const DELETE_REGS_TRACK_INT_URL_SUCCESS = "DELETE_REGS_TRACK_INT_URL_SUCCESS";
export const DELETE_REGS_TRACK_INT_URL_FAILURE = "DELETE_REGS_TRACK_INT_URL_FAILURE";

// Citations
export const PUT_REGS_TRACK_INT_CITATION_START = "PUT_REGS_TRACK_INT_CITATION_START";
export const PUT_REGS_TRACK_INT_CITATION_SUCCESS = "PUT_REGS_TRACK_INT_CITATION_SUCCESS";
export const PUT_REGS_TRACK_INT_CITATION_FAILURE = "PUT_REGS_TRACK_INT_CITATION_FAILURE";

export const POST_REGS_TRACK_INT_CITATION_START = "POST_REGS_TRACK_INT_CITATION_START";
export const POST_REGS_TRACK_INT_CITATION_SUCCESS = "POST_REGS_TRACK_INT_CITATION_SUCCESS";
export const POST_REGS_TRACK_INT_CITATION_FAILURE = "POST_REGS_TRACK_INT_CITATION_FAILURE";

export const DELETE_REGS_TRACK_INT_CITATION_START = "DELETE_REGS_TRACK_INT_CITATION_START";
export const DELETE_REGS_TRACK_INT_CITATION_SUCCESS = "DELETE_REGS_TRACK_INT_CITATION_SUCCESS";
export const DELETE_REGS_TRACK_INT_CITATION_FAILURE = "DELETE_REGS_TRACK_INT_CITATION_FAILURE";

// Histories
export const PUT_REGS_TRACK_INT_HISTORYACTION_START = "PUT_REGS_TRACK_INT_HISTORYACTION_START";
export const PUT_REGS_TRACK_INT_HISTORYACTION_SUCCESS = "PUT_REGS_TRACK_INT_HISTORYACTION_SUCCESS";
export const PUT_REGS_TRACK_INT_HISTORYACTION_FAILURE = "PUT_REGS_TRACK_INT_HISTORYACTION_FAILURE";

export const POST_REGS_TRACK_INT_HISTORYACTION_START = "POST_REGS_TRACK_INT_HISTORYACTION_START";
export const POST_REGS_TRACK_INT_HISTORYACTION_SUCCESS = "POST_REGS_TRACK_INT_HISTORYACTION_SUCCESS";
export const POST_REGS_TRACK_INT_HISTORYACTION_FAILURE = "POST_REGS_TRACK_INT_HISTORYACTION_FAILURE";

export const DELETE_REGS_TRACK_INT_HISTORYACTION_START = "DELETE_REGS_TRACK_INT_HISTORYACTION_START";
export const DELETE_REGS_TRACK_INT_HISTORYACTION_SUCCESS = "DELETE_REGS_TRACK_INT_HISTORYACTION_SUCCESS";
export const DELETE_REGS_TRACK_INT_HISTORYACTION_FAILURE = "DELETE_REGS_TRACK_INT_HISTORYACTION_FAILURE";

// Agencies
export const PUT_REGS_TRACK_INT_AGENCY_START = "PUT_REGS_TRACK_INT_AGENCY_START";
export const PUT_REGS_TRACK_INT_AGENCY_SUCCESS = "PUT_REGS_TRACK_INT_AGENCY_SUCCESS";
export const PUT_REGS_TRACK_INT_AGENCY_FAILURE = "PUT_REGS_TRACK_INT_AGENCY_FAILURE";

export const POST_REGS_TRACK_INT_AGENCY_START = "POST_REGS_TRACK_INT_AGENCY_START";
export const POST_REGS_TRACK_INT_AGENCY_SUCCESS = "POST_REGS_TRACK_INT_AGENCY_SUCCESS";
export const POST_REGS_TRACK_INT_AGENCY_FAILURE = "POST_REGS_TRACK_INT_AGENCY_FAILURE";

export const DELETE_REGS_TRACK_INT_AGENCY_START = "DELETE_REGS_TRACK_INT_AGENCY_START";
export const DELETE_REGS_TRACK_INT_AGENCY_SUCCESS = "DELETE_REGS_TRACK_INT_AGENCY_SUCCESS";
export const DELETE_REGS_TRACK_INT_AGENCY_FAILURE = "DELETE_REGS_TRACK_INT_AGENCY_FAILURE";



export const UPDATE_SUBSCRIBE_DATE_ALL_START = "UPDATE_SUBSCRIBE_DATE_ALL_START";
export const UPDATE_SUBSCRIBE_DATE_ALL_SUCCESS = "UPDATE_SUBSCRIBE_DATE_ALL_SUCCESS";
export const UPDATE_SUBSCRIBE_DATE_ALL_FAILURE = "UPDATE_SUBSCRIBE_DATE_ALL_FAILURE";

// export const GET_REGS_INFO_HISTORY_START = "GET_REGS_INFO_HISTORY_START";
// export const GET_REGS_INFO_HISTORY_FAILURE = "GET_REGS_INFO_HISTORY_FAILURE";
// export const GET_REGS_INFO_HISTORY_SUCCESS = "GET_REGS_INFO_HISTORY_SUCCESS";

export const PUT_REGS_INFO_HISTORY_START = "PUT_REGS_INFO_HISTORY_START";
export const PUT_REGS_INFO_HISTORY_SUCCESS = "PUT_REGS_INFO_HISTORY_SUCCESS";
export const PUT_REGS_INFO_HISTORY_FAILURE = "PUT_REGS_INFO_HISTORY_FAILURE";
export const GET_REGS_INFO_HISTORY_LOG_START = "GET_REGS_INFO_HISTORY_LOG_START";
export const GET_REGS_INFO_HISTORY_LOG_SUCCESS = "GET_REGS_INFO_HISTORY_LOG_SUCCESS";
export const GET_REGS_INFO_HISTORY_LOG_FAILURE = "GET_REGS_INFO_HISTORY_LOG_FAILURE";
export const ADD_REGS_INFO_MANAGMENT_COMMENT_START = "ADD_REGS_INFO_MANAGMENT_COMMENT_START";
export const ADD_REGS_INFO_MANAGMENT_COMMENT_SUCCESS = "ADD_REGS_INFO_MANAGMENT_COMMENT_SUCCESS";
export const ADD_REGS_INFO_MANAGMENT_COMMENT_FAILURE = "ADD_REGS_INFO_MANAGMENT_COMMENT_FAILURE";
export const ADD_SENDALERT_HISTORY_LOG_START = "ADD_SENDALERT_HISTORY_LOG_START";
export const ADD_SENDALERT_HISTORY_LOG_SUCCESS = "ADD_SENDALERT_HISTORY_LOG_SUCCESS";
export const ADD_SENDALERT_HISTORY_LOG_FAILURE = "ADD_SENDALERT_HISTORY_LOG_FAILURE";
export const PUT_REGS_INFO_MANAGEMENT_COMMENT_START = "PUT_REGS_INFO_MANAGEMENT_COMMENT_START";
export const PUT_REGS_INFO_MANAGEMENT_COMMENT_SUCCESS = "PUT_REGS_INFO_MANAGEMENT_COMMENT_SUCCESS";
export const PUT_REGS_INFO_MANAGEMENT_COMMENT_FAILURE = "PUT_REGS_INFO_MANAGEMENT_COMMENT_FAILURE";
export const GET_REGS_INFO_TAG_COMPARISON_START = "GET_REGS_INFO_TAG_COMPARISON_START";
export const GET_REGS_INFO_TAG_COMPARISON_FAILURE = "GET_REGS_INFO_TAG_COMPARISON_FAILURE";
export const GET_REGS_INFO_TAG_COMPARISON_SUCCESS = "GET_REGS_INFO_TAG_COMPARISON_SUCCESS";
export const PUT_COMPANION_BILL_REVIEW_START = "PUT_COMPANION_BILL_REVIEW_START";
export const PUT_COMPANION_BILL_REVIEW_SUCCESS = "PUT_COMPANION_BILL_REVIEW_SUCCESS";
export const PUT_COMPANION_BILL_REVIEW_FAILURE = "PUT_COMPANION_BILL_REVIEW_FAILURE";
export const POST_REGS_INFO_START = "POST_REGS_INFO_START";
export const POST_REGS_INFO_SUCCESS = "POST_REGS_INFO_SUCCESS";
export const POST_REGS_INFO_FAILURE = "POST_REGS_INFO_FAILURE";
export const UPLOAD_DOCUMENT_START = "UPLOAD_DOCUMENT_START";
export const UPLOAD_DOCUMENT_SUCCESS = "UPLOAD_DOCUMENT_SUCCESS";
export const UPLOAD_DOCUMENT_FAILURE = "UPLOAD_DOCUMENT_FAILURE";

const headers = {
  "Content-Type": "application/json",
};

export function getRegsTrackInternalInitialState() {
  return initialState;
}

function formatDateShort(date) {
  return date && date !== "" ? moment(date).format("MM/DD/YYYY") : "";
}

function matchReviewRows(rows) {
  return rows.map((item) => {
    return {
      textValues: {
        team: item.Team || "",
        assignedBy: item.AssignedBy || "",
        assignedDate: formatDate(item.AssignedDate),
        reviewedBy: item.ReviewedBy || "",
        reviewedDate: formatDate(item.ReviewedDate),
        type: item.FlagTypeDesc,
        flag: String(item.FlagType),
      },
      isReviewed: item.ReviewedBy !== null,
    };
  });
}

function matchBaseRecordInfo(info) {
  const recordInfo = {
    textValues: {
      country: info.Country || "",
      contact: info.ContactInformation || "",
      notes: info.Notes || "",
      regsId: info.RegsId,
      loadDate: formatDate(info.LoadDate),
      oldLoadDate: info.OldLoadDate ? formatDate(info.OldLoadDate) : '',
      summary: info.Summary || "",
      url: info.Url || "",
      year: info.Year || "",
      lastUpdateToRecord: formatDate(info.LastUpdateTS),
      lastUpdateUserId: info.LastUpdateId || "",
      title: info.Title || "",
      remarks: info.Remarks || "",
      nextSchedActionDate: formatDate(info.NextSchedAction),
      teams: info.Team || "",
      toolboxUrl: info.ToolboxUrl || "",
    },
    radio: {
      active: info.Active || false,
      state: info.State || "",
      regsType: info.RegsType || "", 
      assignedUser: info.AssignedUser || "",  
    },
    regsProgress: {
      boolValues: {
        // Progress/action flags
        Proposed: info.Proposed || false,
        Published: info.Published || false,
        AgencyAdopted: info.AgencyAdopted || false,
        FinallyAdopted: info.FinallyAdopted || false,
        Effective: info.Effective || false,
        Abandoned: info.Abandoned || false,
        Emergency: info.Emergency || false,
        Other: info.Other || false,
      }
    }
  };

  return matchSubHistoryData(recordInfo, info);
}

function matchRecordInfo(info, baseRecordInfo) {
  const recordCreated = formatDate(info.CreateDate);
  const reviewers = info.Reviewers || [];

  const recordInfo = combineRecordInfo(
    baseRecordInfo,
    recordCreated,
    reviewers
  );

  return matchSubHistoryData(recordInfo, info);
}

function combineRecordInfo(baseRecordInfo, recordCreated, reviewers) {
  return {
    ...baseRecordInfo,
    textValues: {
      ...baseRecordInfo.textValues,
      recordCreated: recordCreated,
      reviewers: reviewers,
    },
  };
}

function matchSubHistoryData(recordInfo, info) {
  return {
    ...recordInfo,
    textValues: {
      ...recordInfo.textValues,
      supplementalHistory: info.SupplementalHistory || "",
      historyRemarks: info.HistoryRemarks || "",
      historyRemarksUpdated: formatDate(info.RemarksUpdated),
      effectiveModifiedDate: formatDate(info.EffectiveModifiedDate),
      effectiveDate: formatDateShort(info.EffectiveDate),
      publicLawNumber: info.PublicActNo || "",
    },
  };
}

function matchDocuments(documents) {
  return documents
    ? documents.map((doc) => {
        return {
          url: doc.Url,
          description: doc.Description,
          urlType: doc.Type,
          id: doc.Id,
        };
      })
    : [];
}

function matchHistoryActions(historyActions) {
  return historyActions
    ? historyActions.map((historyAction) => {
        return matchHistoryAction(historyAction);
      })
    : [];
}

function matchHistoryAction(historyAction) {
  return {
    textValues: {
      CreateDate: formatDate(
        historyAction && historyAction.CreateDate
          ? historyAction.CreateDate
          : new Date()
      ),
      CreateUser:
        historyAction && historyAction.CreateUser
          ? historyAction.CreateUser
          : "",
      HistoryDate: formatDate(
        historyAction && historyAction.HistoryDate
          ? historyAction.HistoryDate
          : new Date()
      ),
      RegsHistoryId:
        historyAction && historyAction.RegsHistoryId
          ? historyAction.RegsHistoryId
          : -1,
      RegsId:
        historyAction && historyAction.RegsId ? historyAction.RegsId : -1,
      NewRecord: historyAction ? false : true,
    },
    radio: {
      HistoryAction:
        historyAction && historyAction.HistoryAction
          ? historyAction.HistoryAction
          : "",
    },
  };
}

function matchRegsAgencys(regsAgencys) {
  return regsAgencys
    ? regsAgencys.map((regsAgency) => {
        return matchRegsAgency(regsAgency);
      })
    : [];
}

function matchRegsAgency(regsAgency = null) {
  const newRegsAgency = {
    textValues: {
      Id: regsAgency && regsAgency.Id ? regsAgency.Id : -1,
      RegsId: regsAgency && regsAgency.RegId ? regsAgency.RegId : -1,
      AgencyId: regsAgency && regsAgency.AgencyId ? regsAgency.AgencyId : -1,
      SortOrder: regsAgency && regsAgency.SortOrder ? regsAgency.SortOrder : 0,
      AgencyName: regsAgency && regsAgency.AgencyName ? regsAgency.AgencyName : "",
      StateCode: regsAgency && regsAgency.StateCode ? regsAgency.StateCode : "",
      NewRecord: regsAgency ? false : true,
    },
    radio: {
      AgencyId: regsAgency && regsAgency.AgencyId 
      ? regsAgency.AgencyId 
      : -1,
    }
  };
  return newRegsAgency;
}

function matchStateAgencyOptions(stateAgencyOptions) {
  return stateAgencyOptions
    ? stateAgencyOptions.map((stateAgencyOption) => {
        return matchStateAgencyOption(stateAgencyOption);
      })
    : [];
}

function matchStateAgencyOption(stateAgencyOption) {
  return {
    value: stateAgencyOption.AgencyId,
    label: stateAgencyOption.AgencyName,
    activeFlag: true,
    AgencyName: stateAgencyOption.AgencyName, 
    AgencyId: stateAgencyOption.AgencyId,
  };
}

// Citations 
function matchRegsCitations(regsCitations){
  return regsCitations
    ? regsCitations.map((regsCitation) => {
        return matchRegsCitation(regsCitation);
      })
    : [];
}

function matchRegsCitation(regsCitation = null) {
  const newRegsCitation = {
    textValues: {
      Id: regsCitation && regsCitation.Id ? regsCitation.Id : -1,
      RegsId: regsCitation && regsCitation.RegId ? regsCitation.RegId : -1,
      CitationName: regsCitation && regsCitation.CitationName ? regsCitation.CitationName : "",
      CitationTypeId: regsCitation && regsCitation.CitationTypeId ? regsCitation.CitationTypeId : -1,
      CitationValue: regsCitation && regsCitation.CitationValue ? regsCitation.CitationValue : "",
      CreateUser: regsCitation && regsCitation.CreateUser ? regsCitation.CreateUser : "",
      CreateDate: formatDate(
        regsCitation && regsCitation.CreateDate
          ? regsCitation.CreateDate
          : new Date()
      ),      
      UserVisible: !regsCitation ? false : regsCitation.UserVisible,
      TagType: regsCitation && regsCitation.TagType ? regsCitation.TagType : "",
      StateCode: regsCitation && regsCitation.StateCode ? regsCitation.StateCode : "",
      DisplaySequence: regsCitation && regsCitation.DisplaySequence ? regsCitation.DisplaySequence : 0,
      AnalystVisible: !regsCitation ? false : regsCitation.AnalystVisible,
      NewRecord: regsCitation ? false : true,
    },
    radio: {
      CitationTypeId: 
        regsCitation && regsCitation.CitationTypeId
          ? regsCitation.CitationTypeId
          : -1,
    },
  };
  return newRegsCitation;
}

function matchStateCitationOptions(stateCitationOptions) {
  return stateCitationOptions
    ? stateCitationOptions.map((stateCitationOption) => {
        return matchStateCitationOption(stateCitationOption);
      })
    : [];
}

function matchStateCitationOption(stateCitationOption) {
  return {
    value: stateCitationOption.CitationTypeId,
    label: stateCitationOption.CitationName,
    activeFlag: stateCitationOption.AnalystVisible,
    CitationName: stateCitationOption.CitationName, 
    CitationTypeId: stateCitationOption.CitationTypeId,
  };
}

// End Citations

// Analysts 
function matchAnalystOptions(analystOptions){
  return analystOptions
    ? analystOptions.map((analystOption) => {
        return matchAnalystOption(analystOption);
      })
    : [];
}

function matchAnalystOption(analystOption){
  return {
    value: analystOption.UserName,
    label: analystOption.FullName + ' (' + analystOption.UserName + ')',
    UserId: analystOption.UserId, 
    Email: analystOption.Email,
    activeFlag: true,
  };
}

// End Analysts

// Histories 

function matchRegsHistoryActions(regsHistoryActions){
  return regsHistoryActions
    ? regsHistoryActions.map((regsHistoryAction) => {
        return matchRegsHistoryAction(regsHistoryAction);
      })
    : [];
}

function matchRegsHistoryAction(regsHistoryAction = null) {
  const newRegsHistoryAction = {
    textValues: {
      RegsHistoryId: regsHistoryAction && regsHistoryAction.RegsHistoryId ? regsHistoryAction.RegsHistoryId : -1,
      RegsId: regsHistoryAction && regsHistoryAction.RegId ? regsHistoryAction.RegId : (regsHistoryAction && regsHistoryAction.RegsId ? regsHistoryAction.RegsId : -1),
      HistoryActionId: regsHistoryAction && regsHistoryAction.HistoryActionId ? regsHistoryAction.HistoryActionId : -1,
      HistoryAction: regsHistoryAction && regsHistoryAction.HistoryAction ? regsHistoryAction.HistoryAction : "",
      HistoryDate: formatDate(
        regsHistoryAction && regsHistoryAction.HistoryDate
          ? regsHistoryAction.HistoryDate
          : new Date()
      ),
      RegsChecks: regsHistoryAction && regsHistoryAction.RegsChecks ? regsHistoryAction.RegsChecks : "",
      DateType: regsHistoryAction && regsHistoryAction.DateType ? regsHistoryAction.DateType : "",
      HistoryRegsType: regsHistoryAction && regsHistoryAction.HistoryRegsType ? regsHistoryAction.HistoryRegsType : 0,
      CreateUser: regsHistoryAction && regsHistoryAction.CreateUser ? regsHistoryAction.CreateUser : "",
      CreateDate: formatDate(
        regsHistoryAction && regsHistoryAction.CreateDate
          ? regsHistoryAction.CreateDate
          : new Date()
      ),
      NewRecord: regsHistoryAction ? false : true,
    },
    radio: {
      HistoryActionId: 
        regsHistoryAction && regsHistoryAction.HistoryActionId
          ? regsHistoryAction.HistoryActionId
          : -1,
    },
  };
  return newRegsHistoryAction;
}

function matchStateHistoryActionOptions(stateHistoryActionOptions) {
  return stateHistoryActionOptions
    ? stateHistoryActionOptions.map((stateHistoryActionOption) => {
        return matchStateHistoryActionOption(stateHistoryActionOption);
      })
    : [];
}

function matchStateHistoryActionOption(stateHistoryActionOption) {
  return {
    value: stateHistoryActionOption.HistoryActionId,
    label: stateHistoryActionOption.HistoryAction,
    activeFlag: true,
    HistoryAction: stateHistoryActionOption.HistoryAction,
    HistoryActionId: stateHistoryActionOption.HistoryActionId,
    RegsChecks: stateHistoryActionOption.RegsChecks,
    HistoryRegsType: stateHistoryActionOption.HistoryRegsType, 
    DateType: stateHistoryActionOption.DateType, 
    SortOrd: stateHistoryActionOption.SortOrd, 
  };
}

// End Histories

function matchRegsUrls(regsUrls) {
  return regsUrls
    ? regsUrls.map((regsUrl) => {
        return matchRegsUrl(regsUrl);
      })
    : [];
}

function matchRegsUrl(regsUrl = null) {
  const newRegsUrl = {
    textValues: {
      Url: regsUrl && regsUrl.Url ? regsUrl.Url : "",
      Description: regsUrl && regsUrl.Description ? regsUrl.Description : "",
      Page: regsUrl && regsUrl.Page ? regsUrl.Page : "",
      Id: regsUrl && regsUrl.Id ? regsUrl.Id : -1,
      RegId: regsUrl && regsUrl.RegId ? regsUrl.RegId : -1,
      LinkUrl: regsUrl && regsUrl.LinkUrl ? regsUrl.LinkUrl : "",
      SSUrl: regsUrl && regsUrl.SSUrl ? regsUrl.SSUrl : "",
      MaintainOnSS:
        !regsUrl ? true : regsUrl.MaintainOnSS,
      UrlBad: !regsUrl ? false : regsUrl.UrlBad,
      UrlCheckedDate: formatDate(
        regsUrl && regsUrl.UrlCheckedDate
          ? regsUrl.UrlCheckedDate
          : new Date()
      ),
      SortOrder: regsUrl && regsUrl.SortOrder ? regsUrl.SortOrder : 0,
      NewRecord: regsUrl && regsUrl.Id ? false : true,
    },
  };

  return newRegsUrl;
}

function matchManagementComments(managementComments) {
  return managementComments
    ? managementComments.map((managementComment) => {
        return matchManagementComment(managementComment);
      })
    : [];
}

function matchManagementComment(managementComment) {
  return {
    textValues: {
      Id: managementComment.Id || "",
      RecordId: managementComment.RecordId || "",
      DataType: managementComment.DataType || "",
      DateAdded: formatDate(managementComment.DateAdded),
      AssignedBy: managementComment.AssignedBy || "",
      Comment: managementComment.Comment || "",
      Response: managementComment.Response || "",
      ResponseBy: managementComment.ResponseBy || "",
      ResponseDate: formatDate(managementComment.ResponseDate),
      MissedBill: !!managementComment.MissedBill,
      LateTagRequest: !!managementComment.LateTagRequest,
      CommentComplete: !!managementComment.CommentComplete,
      Reviewed: !!managementComment.Reviewed,
    },
    radio: {
      TeamAssigned: managementComment.TeamAssigned || "",
    },
  };
}

function matchClientSubjectTags(clientSubjectTags) {
  return clientSubjectTags
    ? clientSubjectTags.map((clientSubjectTag) => {
        return matchClientSubjectTag(clientSubjectTag);
      })
    : [];
}

function matchClientSubjectTag(clientSubjectTag) {
  return {
    SubjectId: clientSubjectTag.SubjectId,
    Client: clientSubjectTag.Client,
    Subject: clientSubjectTag.Subject,
    DataType: clientSubjectTag.DataType,
    RecordId: clientSubjectTag.RecordId,
    SubscribeDate: formatDate(clientSubjectTag.SubscribeDate),
    CreateUser: clientSubjectTag.CreateUser,
    OriginalCreateDate: formatDate(clientSubjectTag.OriginalCreateDate),
    LastUpdateDate: formatDate(clientSubjectTag.LastUpdateDate),
    LastUpdateUser: clientSubjectTag.LastUpdateUser,
    IssueId: clientSubjectTag.IssueId,
    EmailAlerts: clientSubjectTag.EmailAlerts,
    Deleted: clientSubjectTag.Deleted,
    Autoload: clientSubjectTag.Autoload,
    DeletedByAnalyst: clientSubjectTag.DeletedByAnalyst,
    CanEdit: clientSubjectTag.CanEdit,
  };
}

function matchStandardRemarks(standardRemarks) {
  return standardRemarks
    ? standardRemarks.map((standardRemark) => {
        return {
          label: standardRemark,
          value: standardRemark,
        };
      })
    : [];
}

function matchClientActions(info) {
  return info.ClientActions
    ? info.ClientActions.map((action) => {
        return matchClientAction(action);
      })
    : [];
}

function matchClientAction(action) {
  return {
    textValues: {
      stsReviewer: action.StateScapeCheckedBy || "",
      reviewDate: formatDate(action.StateScapeCheckedDate),
      stsComment: action.StateScapeComments || "",
      client: action.Client || "",
      loginId: action.LogonId || "",
      action: action.Action || "",
      changedDate: formatDate(action.ChangeDate),
      userEmail: action.Email || "",
      actionDetails: action.ActionDetail || "",
      clientComment: action.ClientComments || "",
      clientActionId: action.ClientActionId || "",
    },
  };
}

function matchIderInfo(info) {
  return {
    textValues: {
      ider: info.IDer || "",
      iderReviewed: info.IDerReviewed || "",
      iderReviewedDate: formatDate(info.IDerReviewedDate),
    },
  };
}

function matchKeywordHits(hits) {
  return hits.map((hit) => {
    return {
      textValues: {
        team: hit.Team || "",
        client: hit.Client || "",
        grouping: hit.Subject || "",
        keyword: hit.Keyword || "",
        hits: hit.Hits,
        foundDate: formatDate(hit.FoundDate),
        changeDate: formatDate(hit.ChangeDate),
        oldHits: hit.OldHits,
        keywordId: hit.KeywordId,
        taggingInstructions: hit.GroupTaggingInstructions || "",
        description: hit.GroupDescription || "",
        overview: hit.GroupOverview || "",
        boolPhrase: hit.BoolPhrase,
        groupingId: hit.GroupingId,
      },
    };
  });
}

function matchClientSubjects(clients) {
  return clients.map((client) => {
    return {
      textValues: {
        deleted: client.DeleteIt || false,
        client: client.ClientName || "",
        clientDescription: client.ClientDescription || "",
        subject: client.Subject || "",
        subjectDescription: client.SubjectDescription || "",
        changeDate: formatDate(client.CreateDate),
        user: client.CreateUserId || "",
      },
    };
  });
}

function matchRegsHistory(history) {
  const actionFlags = [
    'Proposed',
    'Published',
    'AgencyAdopted',
    'FinallyAdopted',
    'Effective',
    'Abandoned',
    'Emergency',
    'Other',
  ]
  let obj = {
    boolValues: history,
    selected: Object.keys(history).filter(
      (key) => history[key] && typeof history[key] == "boolean"
    ),
    initialSelected: Object.keys(history).filter(
      (key) => history[key] && typeof history[key] == "boolean"
    ),
    initialValues: {},
  };
  actionFlags.forEach(function(i){
    obj.initialValues[i] = history[i] == true;
  })
  return obj;
}

function matchRegsHistoryDisabledItems(regsType){
  let disabled = [];
  if (regsType != 'Regulation'){
    disabled = [
    'Proposed',
    'Published',
    'AgencyAdopted',
    'FinallyAdopted',
    'Effective',
    'Emergency',
    'Other',
    ];
  }
  return disabled;
}

function matchQCKeywordReview(keywordsReview) {
  return keywordsReview.map((keywordReview) => {
    return {
      textValues: {
        reviewDate: formatDate(keywordReview.ReviewDate),
        reviewer: keywordReview.Reviewer || "",
        client: keywordReview.Client || "",
        subject: keywordReview.Subject || "",
      },
    };
  });
}

function matchQCKeywordMissing(keywordsMissing) {
  return keywordsMissing.map((keywordMissing) => {
    return {
      textValues: {
        client: keywordMissing.Client || "",
        subject: keywordMissing.Subject || "",
        team: keywordMissing.Team || "",
        id: keywordMissing.Id || "",
        reviewed: keywordMissing.Reviewed || "",
      },
    };
  });
}

function matchHistoryLog(historyLog) {
  return historyLog.map((log) => {
    return {
      HistoryDate: log.CreateDate,
      User: log.UserName,
      HistoryAction: log.Activity,
    };
  });
}

// ------------------------------------
// Actions
// ------------------------------------

const getReviewData = (regsId) => {
  return (dispatch) =>
    dispatch(getRegsTrackBase(regsId, dispatch)).then(() => {
      Promise.all([
        dispatch(getRegsKeywords(regsId)),
        dispatch(getRegsHistoryLog(regsId)),
      ]);
    });
};

export function openReviewRecord(regsId) {
  return (dispatch) => {
    dispatch({ type: REGS_TRACK_INT_OPEN_RECORD_START });
    dispatch(getReviewData(regsId, dispatch)).finally(() => {
      dispatch({
        type: OPEN_REGS_TRACK_RECORD_SUCCESS,
        payload: { regsId },
      });
    });
  };
}

// used to refresh client subject tags as they can be altered on 
// the groupings page while an analyst is making edits to a Reg. 
export function getClientSubjectTags(regsId) {
  return (dispatch) =>
    dispatch(getRegsTrackClientSubjects(regsId, dispatch));
};

const getInitialData = () => {
  return (dispatch) =>
    Promise.all([
      dispatch(getRegsTrackInternalQueryData()),
    ]);
};

export function loadInitialData() {
  return (dispatch) =>
    Promise.all([
      dispatch({ type: GET_REGS_TRACK_INITIAL_DATA_START }),
      dispatch(getInitialData()).finally(() => {
        dispatch({ type: GET_REGS_TRACK_INITIAL_DATA_COMPLETE });
      }),
    ]);
}

export function getRegsTrackInternalQueryData() {
  return (dispatch) => {
    dispatch({ type: GET_REGS_TRACK_INT_QUERY_DATA_START });
    const options = {
      method: "GET",
      credentials: "include",
    };
    return fetch(`${globals.apiUrl}/RegsTrackIntQuery`, options)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (response.status === 400) {
          response.text().then((text) => {
            if (text) {
              dispatch({
                type: GET_REGS_TRACK_INT_QUERY_DATA_FAILURE,
                json: text,
              });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .then((json) => {
        if (json) {
          dispatch({
            type: GET_REGS_TRACK_INT_QUERY_DATA_SUCCESS,
            payload: {
              json,
            },
          });
        }
      })
      .catch((err) => {
        dispatch({
          type: GET_REGS_TRACK_INT_QUERY_DATA_FAILURE,
          json: err.message,
        });
      });
  };
}

export function postRegsTrackInternal(regsTrackIntParameters) {
  return (dispatch) => {
    dispatch({ type: POST_REGS_TRACK_DATA_START });
    const options = {
      method: "POST",
      credentials: "include",
      headers,
      body: JSON.stringify(regsTrackIntParameters),
    };
    return fetch(`${globals.apiUrl}/RegsTrackIntQuery`, options)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (response.status === 400) {
          response.text().then((text) => {
            if (text) {
              dispatch({
                type: POST_REGS_TRACK_DATA_FAILURE,
                json: text,
              });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .then((json) => {
        if (json) {
          dispatch({
            type: POST_REGS_TRACK_DATA_SUCCESS,
            payload: {
              json,
            },
          });
          if (json.length > 0) {
            dispatch(openReviewRecord(json[0]));
          } else {
            dispatch(showModal("No-results"));
            dispatch(clearFormFields());
          }
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({
          type: POST_REGS_TRACK_DATA_FAILURE,
          json: err.message,
        });
      });
  };
}

export function postRegsTrack(regsTrackInfo) {
  return (dispatch) => {
    dispatch({ type: POST_REGS_INFO_START });
    const options = {
      method: "Post",
      credentials: "include",
      headers,
      body: JSON.stringify(regsTrackInfo),
    };
    return fetch(`${globals.apiUrl}/regstrackint`, options)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (response.status === 400) {
          response.text().then((text) => {
            if (text) {
              dispatch({
                type: POST_REGS_INFO_FAILURE,
                json: text,
              });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .then((json) => {
        if (json) {
          dispatch({
            type: POST_REGS_INFO_SUCCESS,
            payload: {
              baseRecordInfo: matchBaseRecordInfo(json),
            },
          });

          return json;
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({
          type: POST_REGS_INFO_FAILURE,
          json: err.message,
        });
      });
  };
}

export function putRegsTrackInfo(regsTrackInfo) {
  return (dispatch) => {
    dispatch({ type: PUT_REGS_INFO_START });
    const options = {
      method: "Put",
      credentials: "include",
      headers,
      body: JSON.stringify(regsTrackInfo),
    };
    return fetch(`${globals.apiUrl}/regstrackint`, options)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (response.status === 400) {
          response.text().then((text) => {
            if (text) {
              dispatch({
                type: PUT_REGS_INFO_FAILURE,
                json: text,
              });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .then((json) => {
        if (json) {
          dispatch({
            type: PUT_REGS_INFO_SUCCESS,
            payload: {
              baseRecordInfo: matchBaseRecordInfo(json),
            },
          });

          return json;
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({
          type: PUT_REGS_INFO_FAILURE,
          json: err.message,
        });
      });
  };
}

export function putClientAction(clientActionId, reviewComments) {
  return (dispatch) => {
    dispatch({ type: PUT_CLIENT_ACTION_START });
    const options = {
      method: "Put",
      credentials: "include",
      headers,
      body: JSON.stringify({
        ClientActionId: clientActionId, 
        StateScapeComments: reviewComments ? reviewComments : '',
      }),
    };
    return fetch(`${globals.apiUrl}/clientaction`, options)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (response.status === 400) {
          response.text().then((text) => {
            if (text) {
              dispatch({
                type: PUT_CLIENT_ACTION_FAILURE,
                json: text,
              });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .then((json) => {
        if (json) {
          dispatch({
            type: PUT_CLIENT_ACTION_SUCCESS,
            payload: {
              json,
            },
          });
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({
          type: PUT_CLIENT_ACTION_FAILURE,
          json: err.message,
        });
      });
  };
}

export function putClientActionComment(clientAction, arrayIndex) {
  return (dispatch) => {
    dispatch({ type: PUT_CLIENT_ACTION_COMMENT_START });
    const options = {
      method: "Put",
      credentials: "include",
      headers,
      body: JSON.stringify(clientAction),
    };
    return fetch(`${globals.apiUrl}/clientactioncomment`, options)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (response.status === 400) {
          response.text().then((text) => {
            if (text) {
              dispatch({
                type: PUT_CLIENT_ACTION_COMMENT_FAILURE,
                json: text,
              });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .then((json) => {
        if (json) {
          dispatch({
            type: PUT_CLIENT_ACTION_COMMENT_SUCCESS,
            payload: {
              json,
              arrayIndex,
            },
          });
          return json;
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({
          type: PUT_CLIENT_ACTION_COMMENT_FAILURE,
          json: err.message,
        });
      });
  };
}

export function getRegsTeamReview(id) {
  return (dispatch) => {
    dispatch({ type: GET_REGS_TRACK_TEAM_REVIEW_DATA_START });
    const options = {
      method: "GET",
      credentials: "include",
    };
    return fetch(`${globals.apiUrl}/RawFile/TeamReview/${id}`, options)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (response.status === 400) {
          response.text().then((text) => {
            if (text) {
              dispatch({
                type: GET_REGS_TRACK_TEAM_REVIEW_DATA_FAILURE,
                json: text,
              });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .then((json) => {
        if (json) {
          dispatch({
            type: GET_REGS_TRACK_TEAM_REVIEW_DATA_SUCCESS,
            payload: {
              json,
              id,
            },
          });
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({
          type: GET_REGS_TRACK_TEAM_REVIEW_DATA_FAILURE,
          json: err.message,
        });
      });
  };
}

// export function postRegsTeamsReview(id, teams, reviewed, flagType) {
//   return (dispatch) => {
//     dispatch({ type: SET_REGS_TRACK_TEAMS_REVIEW_DATA_START });
//     const options = {
//       method: "POST",
//       credentials: "include",
//       headers,
//       body: JSON.stringify({
//         regsId: id,
//         team: teams[0],
//         reviewed: reviewed,
//         flagType: flagType,
//       }),
//     };
//     return fetch(`${globals.apiUrl}/RawFile/TeamReview`, options)
//       .then((response) => {
//         if (response.status === 200) {
//           return response.json();
//         } else if (response.status === 401) {
//           dispatch(logOut());
//         } else if (response.status === 400) {
//           response.text().then((text) => {
//             if (text) {
//               dispatch({
//                 type: SET_REGS_TRACK_TEAMS_REVIEW_DATA_FAILURE,
//                 json: text,
//               });
//               dispatch(showModal("Error"));
//             }
//           });
//         }
//       })
//       .then((json) => {
//         if (json) {
//           dispatch({
//             type: SET_REGS_TRACK_TEAMS_REVIEW_DATA_SUCCESS,
//             payload: {
//               json,
//               id,
//             },
//           });
//         }
//       })
//       .catch((err) => {
//         console.log(err);
//         dispatch({
//           type: SET_REGS_TRACK_TEAMS_REVIEW_DATA_FAILURE,
//           json: err.message,
//         });
//       });
//   };
// }

export function getRegsTrackClientSubjects(id) {
  return (dispatch) => {
    dispatch({ type: GET_REGS_TRACK_CLIENTSUBJECT_START });
    const options = {
      method: "GET",
      credentials: "include",
    };
    return fetch(`${globals.apiUrl}/v2/RegsTrackInt/${id}`, options)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (response.status === 400) {
          response.text().then((text) => {
            if (text) {
              dispatch({ type: GET_REGS_TRACK_CLIENTSUBJECT_FAILURE, json: text });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .then((json) => {
        if (json) {
          const recordInfo = matchRecordInfo(json, matchBaseRecordInfo(json));
          const clientSubjectTags = matchClientSubjectTags(json.ClientSubjects);
          // dispatch(clearHistory(pageIndex.regsTrackInternal));
          dispatch({
            type: GET_REGS_TRACK_CLIENTSUBJECT_SUCCESS,
            payload: {
              clientSubjectTags,
            },
          });
          dispatch(
            setUpdatedValues(pageIndex.regsTrackInternal, {
              clientSubjectTags,
            })
          );
          return recordInfo;
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({ type: GET_REGS_TRACK_CLIENTSUBJECT_FAILURE, json: err.message });
      });
  };
}

export function getRegsTrackBase(id) {
  return (dispatch) => {
    dispatch({ type: GET_REGS_TRACK_BASE_START });
    const options = {
      method: "GET",
      credentials: "include",
    };
    return fetch(`${globals.apiUrl}/v2/RegsTrackInt/${id}`, options)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (response.status === 400) {
          response.text().then((text) => {
            if (text) {
              dispatch({ type: GET_REGS_TRACK_BASE_FAILURE, json: text });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .then((json) => {
        if (json) {
          const recordInfo = matchRecordInfo(json, matchBaseRecordInfo(json));
          const clientActions = matchClientActions(json);
          const standardRemarks = matchStandardRemarks(json.StandardRemarks);
          const documents = matchDocuments(json.Documents);
          const clientSubjectTags = matchClientSubjectTags(json.ClientSubjects);
          const managementComments = matchManagementComments(json.ManagementComments);          
          const regsHistoryActions = matchRegsHistoryActions(json.RegsHistoryActions).sort(
            (a, b) => b.HistoryDate - a.HistoryDate
          );
          const stateHistoryActions = matchStateHistoryActionOptions(
            json.StateHistoryActions
          );
          const regsUrls = matchRegsUrls(json.RegsUrls).sort(
            (a, b) => a.textValues.SortOrder - b.textValues.SortOrder
          );
          const regsCitations = matchRegsCitations(json.RegsCitations).sort(
            (a, b) => a.textValues.DisplaySequence - b.textValues.DisplaySequence
          );
          const stateCitations = matchStateCitationOptions(json.StateCitations);
          const regsAgencys = matchRegsAgencys(json.RegsAgencys).sort(
            (a, b) => a.textValues.SortOrder - b.textValues.SortOrder
          );          
          const stateAgencys = matchStateAgencyOptions(json.StateAgencys);
          const regsProgress = matchRegsHistory(recordInfo.regsProgress.boolValues);
          regsProgress.disabled = matchRegsHistoryDisabledItems(recordInfo.radio.regsType);

          const analysts = matchAnalystOptions(json.Analysts)
          .sort((a, b) => {
            const nameA = a.label.toUpperCase();
            const nameB = b.label.toUpperCase();
            if (nameA < nameB) { return -1; }
            if (nameA > nameB) { return 1; }
            return 0;
          });

          dispatch(clearHistory(pageIndex.regsTrackInternal));
          dispatch({
            type: GET_REGS_TRACK_BASE_SUCCESS,
            payload: {
              recordInfo,
              clientActions,
              documents,
              clientSubjectTags,
              managementComments,
              standardRemarks,
              regsUrls,
              regsCitations,
              stateCitations,
              regsHistoryActions,
              stateHistoryActions,
              regsAgencys, 
              stateAgencys,
              regsProgress,
              analysts,
            },
          });          
          dispatch(
            saveInitialValues(pageIndex.regsTrackInternal, {
              recordInfo,
              clientActions,
              documents,
              clientSubjectTags,
              managementComments,
              standardRemarks,
              regsUrls,
              regsCitations,
              stateCitations,
              regsHistoryActions,
              stateHistoryActions,
              regsAgencys, 
              stateAgencys,
              regsProgress,
            })
          );

          return recordInfo;
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({ type: GET_REGS_TRACK_BASE_FAILURE, json: err.message });
      });
  };
}

export function moveURL(urlIndex, regsUrls, direction) {
  return (dispatch) => {
    const { regsUrlCurrent, regsUrlNext } = moveUrlOrder(
      urlIndex,
      regsUrls,
      direction
    );

    dispatch(
      updateRegsTrackIntURL(regsUrlCurrent.textValues, urlIndex - direction)
    );
    dispatch(updateRegsTrackIntURL(regsUrlNext.textValues, urlIndex));
  };
}

export function moveAgency(agencyIndex, regsAgencys, direction) {
  return (dispatch) => {
    const { regsAgencyCurrent, regsAgencyNext } = moveAgencyOrder(
      agencyIndex,
      regsAgencys,
      direction
    );

    dispatch(
      updateRegsTrackIntAgency(regsAgencyCurrent.textValues, agencyIndex - direction)
    );
    dispatch(updateRegsTrackIntAgency(regsAgencyNext.textValues, agencyIndex));
  };
}

export function getRegsTrackIds(locality, meetingDate) {
  return (dispatch) => {
    dispatch({ type: GET_REGS_TRACK_IDS_START });
    const options = {
      method: "GET",
      credentials: "include",
    };

    const url = new URL(`${globals.apiUrl}/RegsTrackInt/`);

    const params = {
      locality,
      meetingDate,
    };

    if (Object.keys(params)) {
      Object.keys(params).forEach((key) => {
        if (params[key]) {
          url.searchParams.append(key, params[key]);
        }
      });
    }

    return fetch(url, options)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (response.status === 400) {
          response.text().then((text) => {
            if (text) {
              dispatch({ type: GET_REGS_TRACK_IDS_FAILURE, json: text });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .then((json) => {
        if (json) {
          return json;
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({ type: GET_REGS_TRACK_IDS_FAILURE, json: err.message });
      });
  };
}

export function postIdReviewed(id) {
  return (dispatch) => {
    dispatch({ type: SET_REGS_TRACK_ID_REVIEWED_START });
    const options = {
      method: "POST",
      credentials: "include",
      headers,
      body: id,
    };
    return fetch(`${globals.apiUrl}/RawFile/IdReview`, options)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (response.status === 400) {
          response.text().then((text) => {
            if (text) {
              dispatch({
                type: SET_REGS_TRACK_ID_REVIEWED_FAILURE,
                json: text,
              });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .then((json) => {
        if (json) {
          dispatch({
            type: SET_REGS_TRACK_ID_REVIEWED_SUCCESS,
            payload: {
              json,
            },
          });
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({
          type: SET_REGS_TRACK_ID_REVIEWED_FAILURE,
          json: err.message,
        });
      });
  };
}

export function getRegsKeywords(id) {
  return (dispatch) => {
    dispatch({ type: GET_REGS_TRACK_KEYWORDS_START });
    const options = {
      method: "GET",
      credentials: "include",
    };
    return fetch(`${globals.apiUrl}/RawFile/GetKeywords/${id}`, options)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (response.status === 400) {
          response.text().then((text) => {
            if (text) {
              dispatch({ type: GET_REGS_TRACK_KEYWORDS_FAILURE, json: text });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .then((json) => {
        if (json) {
          dispatch({
            type: GET_REGS_TRACK_KEYWORDS_SUCCESS,
            payload: {
              json,
            },
          });
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({ type: GET_REGS_TRACK_KEYWORDS_FAILURE, json: err.message });
      });
  };
}

export function getQCKeywordReview(id) {
  return (dispatch) => {
    dispatch({ type: GET_QC_KEYWORD_REVIEW_START });
    const options = {
      method: "GET",
      credentials: "include",
    };
    return fetch(`${globals.apiUrl}/RawFile/GetQCKeywordReview/${id}`, options)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (response.status === 400) {
          response.text().then((text) => {
            if (text) {
              dispatch({
                type: GET_QC_KEYWORD_REVIEW_FAILURE,
                json: text,
              });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .then((json) => {
        if (json) {
          dispatch({
            type: GET_QC_KEYWORD_REVIEW_SUCCESS,
            payload: {
              json,
            },
          });
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({
          type: GET_QC_KEYWORD_REVIEW_FAILURE,
          json: err.message,
        });
      });
  };
}

export function getQCKeywordMissing(id) {
  return (dispatch) => {
    dispatch({ type: GET_QC_KEYWORD_MISSING_START });
    const options = {
      method: "GET",
      credentials: "include",
    };
    return fetch(`${globals.apiUrl}/RawFile/GetQCKeywordMissing/${id}`, options)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (response.status === 400) {
          response.text().then((text) => {
            if (text) {
              dispatch({
                type: GET_QC_KEYWORD_MISSING_FAILURE,
                json: text,
              });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .then((json) => {
        if (json) {
          dispatch({
            type: GET_QC_KEYWORD_MISSING_SUCCESS,
            payload: {
              json,
            },
          });
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({
          type: GET_QC_KEYWORD_MISSING_FAILURE,
          json: err.message,
        });
      });
  };
}

export function getSubjectGroupList(client, subject) {
  return (dispatch) => {
    dispatch({ type: GET_REGS_TRACK_SUBJECT_GROUP_LIST_START });

    const options = {
      method: "GET",
      credentials: "include",
    };

    const url = new URL(`${globals.apiUrl}/SubjectGroupList`);

    const params = {
      client,
      subject,
      searchType: "Regs",
    };

    if (Object.keys(params)) {
      Object.keys(params).forEach((key) => {
        if (params[key]) {
          url.searchParams.append(key, params[key]);
        }
      });
    }

    return fetch(url, options)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (response.status === 400) {
          response.text().then((text) => {
            if (text) {
              dispatch({
                type: GET_REGS_TRACK_SUBJECT_GROUP_LIST_FAILURE,
                json: text,
              });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .then((json) => {
        if (json) {
          dispatch({
            type: GET_REGS_TRACK_SUBJECT_GROUP_LIST_SUCCESS,
            payload: {
              json,
            },
          });
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({
          type: GET_REGS_TRACK_SUBJECT_GROUP_LIST_FAILURE,
          json: err.message,
        });
      });
  };
}

export function getHighlightedDocument(teams, keywords, path) {
  return (dispatch) => {
    dispatch({ type: GET_REGS_TRACK_HIGHLIGHTED_DOC_START });

    const options = {
      method: "GET",
      credentials: "include",
    };

    const url = new URL(`${globals.apiUrl}/KeywordHits`);

    const params = {
      docpath: path,
      service: "regs",
    };

    if (Object.keys(params)) {
      Object.keys(params).forEach((key) => {
        if (params[key]) {
          url.searchParams.append(key, params[key]);
        }
      });
    }

    if (teams && teams.length != 0) {
      teams.forEach((team) => {
        if (String(team).length > 0) {
          url.searchParams.append("teamId", team);
        }
      });
    }

    if (keywords && keywords.length != 0) {
      keywords.forEach((keyword) =>
        url.searchParams.append("keywordId", keyword)
      );
    }

    return fetch(url, options)
      .then((response) => {
        if (response.status === 200) {
          return response.url;
        } else if (response.status === 302) {
          return response.url;
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (response.status === 400) {
          response.text().then((text) => {
            if (text) {
              dispatch({
                type: GET_REGS_TRACK_HIGHLIGHTED_DOC_FAILURE,
                json: text,
              });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .then((url) => {
        if (url) {
          dispatch({
            type: GET_REGS_TRACK_HIGHLIGHTED_DOC_SUCCESS,
            payload: {
              url,
            },
          });
          return url;
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({
          type: GET_REGS_TRACK_HIGHLIGHTED_DOC_FAILURE,
          json: "Highlighting document: " + err.message,
        });
        dispatch(showModal("Error"));
      });
  };
}

export function postQCKeywordReview(rawfileId, team, customName) {
  return (dispatch) => {
    dispatch({ type: SET_QC_KEYWORD_REVIEW_START });

    const options = {
      method: "POST",
      credentials: "include",
      headers,
      body: JSON.stringify({ rawfileId, team, customName }),
    };

    return fetch(`${globals.apiUrl}/RawFile/QCKeywordReview`, options)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (response.status === 400) {
          response.text().then((text) => {
            if (text) {
              dispatch({ type: SET_QC_KEYWORD_REVIEW_FAILURE, json: text });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .then((success) => {
        return success;
      })
      .catch((err) => {
        console.log(err);
        dispatch({ type: SET_QC_KEYWORD_REVIEW_FAILURE, json: err.message });
      });
  };
}

export function deleteRegsDocument(docId) {
  return (dispatch) => {
    dispatch({ type: DELETE_REGS_INFO_DOC_START });

    const options = {
      method: "DELETE",
      credentials: "include",
    };

    const url = new URL(`${globals.apiUrl}/regsdoc/${docId}`);

    return fetch(url, options)
      .then((response) => {
        if (response.status === 204 || response.status === 200) {
          dispatch({
            type: DELETE_REGS_INFO_DOC_SUCCESS,
            payload: {
              docId,
            },
          });
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (
          response.status === 400 ||
          response.status === 404 ||
          response.status === 409 ||
          response.status === 500
        ) {
          response.text().then((text) => {
            if (text) {
              dispatch({ type: DELETE_REGS_INFO_DOC_FAILURE, json: text });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({ type: DELETE_REGS_INFO_DOC_FAILURE, json: err.message });
      });
  };
}

export function flipLockLoadDate() {
  return (dispatch) => {
    dispatch({ type: FLIP_REGS_INFO_RECORD_LOCK_LOAD_DATE });
  };
}

export function deleteRegsRecord(regsId) {
  return (dispatch) => {
    dispatch({ type: DELETE_REGS_INFO_RECORD_START });

    const options = {
      method: "DELETE",
      credentials: "include",
    };

    const url = new URL(`${globals.apiUrl}/regstrackint/${regsId}`);

    return fetch(url, options)
      .then((response) => {
        if (response.status === 204 || response.status === 200) {
          dispatch({
            type: DELETE_REGS_INFO_RECORD_SUCCESS,
            payload: {
              regsId,
            },
          });
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (
          response.status === 400 ||
          response.status === 404 ||
          response.status === 409 ||
          response.status === 500
        ) {
          response.text().then((text) => {
            if (text) {
              dispatch({ type: DELETE_REGS_INFO_RECORD_FAILURE, json: text });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({ type: DELETE_REGS_INFO_RECORD_FAILURE, json: err.message });
      });
  };
}

export function addRegsDocument(document) {
  return (dispatch) => {
    dispatch({ type: ADD_REGS_INFO_DOC_START });

    const { type, url, description, linkedRecord } = document;

    const options = {
      method: "POST",
      credentials: "include",
      headers,
      body: JSON.stringify({
        Type: type,
        Url: url,
        Description: description,
        RawFileId: linkedRecord,
      }),
    };

    return fetch(`${globals.apiUrl}/regsdoc`, options)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (response.status === 400 || response.status === 409) {
          response.text().then((text) => {
            if (text) {
              dispatch({
                type: ADD_REGS_INFO_DOC_FAILURE,
                json: text,
              });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .then((json) => {
        if (json) {
          dispatch({
            type: ADD_REGS_INFO_DOC_SUCCESS,
            payload: {
              json,
            },
          });
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({
          type: ADD_REGS_INFO_DOC_FAILURE,
          json: err.message,
        });
      });
  };
}

// Start Regs SiteURLs 

export function addRegsTrackIntURL(regsTrackUrl, arrayIndex) {
  return (dispatch) => {
    dispatch({ type: POST_REGS_TRACK_INT_URL_START });

    const options = {
      method: "POST",
      credentials: "include",
      headers,
      body: JSON.stringify({
        regId: regsTrackUrl.RegsId,
        description: regsTrackUrl.Description,
        url: regsTrackUrl.Url,
        maintainOnSS: regsTrackUrl.MaintainOnSS,
        page: regsTrackUrl.Page,
      }),
    };

    return fetch(`${globals.apiUrl}/RegsTrackIntUrl`, options)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (
          response.status === 400 ||
          response.status === 409 ||
          response.status === 404 ||
          response.status === 500
        ) {
          response.text().then((text) => {
            if (text) {
              dispatch({
                type: POST_REGS_TRACK_INT_URL_FAILURE,
                json: text,
              });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .then((json) => {
        if (json) {
          dispatch({
            type: POST_REGS_TRACK_INT_URL_SUCCESS,
            payload: {
              json,
              arrayIndex,
            },
          });

          return json;
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({
          type: POST_REGS_TRACK_INT_URL_FAILURE,
          json: err.message,
        });
      });
  };
}

export function updateRegsTrackIntURL(regsTrackUrl, arrayIndex) {
  return (dispatch) => {
    dispatch({ type: PUT_REGS_TRACK_INT_URL_START });
    const options = {
      method: "Put",
      credentials: "include",
      headers,
      body: [JSON.stringify(regsTrackUrl)],
    };
    return fetch(`${globals.apiUrl}/RegsTrackIntUrl`, options)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (
          response.status === 400 ||
          response.status === 500 ||
          response.status === 404
        ) {
          response.text().then((text) => {
            if (text) {
              dispatch({
                type: PUT_REGS_TRACK_INT_URL_FAILURE,
                json: text,
              });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .then((json) => {
        if (json) {
          dispatch({
            type: PUT_REGS_TRACK_INT_URL_SUCCESS,
            payload: {
              json,
              arrayIndex,
            },
          });

          return json;
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({
          type: PUT_REGS_TRACK_INT_URL_FAILURE,
          json: err.message,
        });
      });
  };
}

// End Regs SiteURLs

// Start Regs Citations 

export function addRegsTrackIntCitation(regsTrackCitation, arrayIndex) {
  return (dispatch) => {
    dispatch({ type: POST_REGS_TRACK_INT_CITATION_START });

    const options = {
      method: "POST",
      credentials: "include",
      headers,
      body: JSON.stringify({
        regId: regsTrackCitation.RegsId,
        citationTypeId: regsTrackCitation.CitationTypeId, 
        citationValue: regsTrackCitation.CitationValue, 
      }),
    };

    return fetch(`${globals.apiUrl}/RegsTrackIntCitation`, options)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (
          response.status === 400 ||
          response.status === 409 ||
          response.status === 404 ||
          response.status === 500
        ) {
          response.text().then((text) => {
            if (text) {
              dispatch({
                type: POST_REGS_TRACK_INT_CITATION_FAILURE,
                json: text,
              });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .then((json) => {
        if (json) {
          dispatch({
            type: POST_REGS_TRACK_INT_CITATION_SUCCESS,
            payload: {
              json,
              arrayIndex,
            },
          });
          return json;
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({
          type: POST_REGS_TRACK_INT_CITATION_FAILURE,
          json: err.message,
        });
      });
  };
}

export function updateRegsTrackIntCitation(regsTrackCitation, arrayIndex) {
  return (dispatch) => {
    dispatch({ type: PUT_REGS_TRACK_INT_CITATION_START });
    const options = {
      method: "Put",
      credentials: "include",
      headers,
      body: [JSON.stringify(regsTrackCitation)],
    };
    return fetch(`${globals.apiUrl}/RegsTrackIntCitation`, options)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (
          response.status === 400 ||
          response.status === 500 ||
          response.status === 404
        ) {
          response.text().then((text) => {
            if (text) {
              dispatch({
                type: PUT_REGS_TRACK_INT_CITATION_FAILURE,
                json: text,
              });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .then((json) => {
        if (json) {
          dispatch({
            type: PUT_REGS_TRACK_INT_CITATION_SUCCESS,
            payload: {
              json,
              arrayIndex,
            },
          });
          return json;
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({
          type: PUT_REGS_TRACK_INT_CITATION_FAILURE,
          json: err.message,
        });
      });
  };
}

// End Regs Citations

// Start Regs HistoryActions 

export function addRegsTrackIntHistoryAction(regsTrackHistoryAction, arrayIndex) {
  return (dispatch) => {
    dispatch({ type: POST_REGS_TRACK_INT_HISTORYACTION_START });

    const options = {
      method: "POST",
      credentials: "include",
      headers,
      body: JSON.stringify({
        regsId: regsTrackHistoryAction.RegsId,
        historyActionId: regsTrackHistoryAction.HistoryActionId,
        historyDate: regsTrackHistoryAction.HistoryDate,
        createDate: regsTrackHistoryAction.CreateDate,
        createUser: regsTrackHistoryAction.CreateUser,
      }),
    };

    return fetch(`${globals.apiUrl}/RegsTrackIntHistory`, options)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (
          response.status === 400 ||
          response.status === 409 ||
          response.status === 404 ||
          response.status === 500
        ) {
          response.text().then((text) => {
            if (text) {
              dispatch({
                type: POST_REGS_TRACK_INT_HISTORYACTION_FAILURE,
                json: text,
              });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .then((json) => {
        if (json) {
          dispatch({
            type: POST_REGS_TRACK_INT_HISTORYACTION_SUCCESS,
            payload: {
              json,
              arrayIndex,
            },
          });
          return json;
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({
          type: POST_REGS_TRACK_INT_HISTORYACTION_FAILURE,
          json: err.message,
        });
      });
  };
}

export function updateRegsTrackIntHistoryAction(regsTrackHistoryAction, arrayIndex) {
  return (dispatch) => {
    dispatch({ type: PUT_REGS_TRACK_INT_HISTORYACTION_START });
    const options = {
      method: "Put",
      credentials: "include",
      headers,
      body: [JSON.stringify(regsTrackHistoryAction)],
    };
    return fetch(`${globals.apiUrl}/RegsTrackIntHistory`, options)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (
          response.status === 400 ||
          response.status === 500 ||
          response.status === 404
        ) {
          response.text().then((text) => {
            if (text) {
              dispatch({
                type: PUT_REGS_TRACK_INT_HISTORYACTION_FAILURE,
                json: text,
              });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .then((json) => {
        if (json) {
          dispatch({
            type: PUT_REGS_TRACK_INT_HISTORYACTION_SUCCESS,
            payload: {
              json,
              arrayIndex,
            },
          });
          return json;
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({
          type: PUT_REGS_TRACK_INT_HISTORYACTION_FAILURE,
          json: err.message,
        });
      });
  };
}

export function setRunRules(doRulesNeedToBeExecuted){
  return (dispatch) => {
    let rType = doRulesNeedToBeExecuted ? SET_RUNRULES_TRUE : SET_RUNRULES_FALSE;
    dispatch({ type: rType });
  };
}

// End Regs HistoryActions

// Start Regs Agencys. Spelled this way for code management purposes of Agencys/Agency. (instead of Agencies/Agency.) 

export function addRegsTrackIntAgency(regsTrackAgency, arrayIndex) {
  return (dispatch) => {
    dispatch({ type: POST_REGS_TRACK_INT_AGENCY_START });

    const options = {
      method: "POST",
      credentials: "include",
      headers,
      body: JSON.stringify({
        regId: regsTrackAgency.RegsId,
        agencyId: regsTrackAgency.AgencyId, 
      }),
    };

    return fetch(`${globals.apiUrl}/RegsTrackIntAgency`, options)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (
          response.status === 400 ||
          response.status === 409 ||
          response.status === 404 ||
          response.status === 500
        ) {
          response.text().then((text) => {
            if (text) {
              dispatch({
                type: POST_REGS_TRACK_INT_AGENCY_FAILURE,
                json: text,
              });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .then((json) => {
        if (json) {
          dispatch({
            type: POST_REGS_TRACK_INT_AGENCY_SUCCESS,
            payload: {
              json,
              arrayIndex,
            },
          });
          return json;
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({
          type: POST_REGS_TRACK_INT_AGENCY_FAILURE,
          json: err.message,
        });
      });
  };
}

export function updateRegsTrackIntAgency(regsTrackAgency, arrayIndex) {
  return (dispatch) => {
    dispatch({ type: PUT_REGS_TRACK_INT_AGENCY_START });
    const options = {
      method: "Put",
      credentials: "include",
      headers,
      body: [JSON.stringify(regsTrackAgency)],
    };
    return fetch(`${globals.apiUrl}/RegsTrackIntAgency`, options)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (
          response.status === 400 ||
          response.status === 500 ||
          response.status === 404
        ) {
          response.text().then((text) => {
            if (text) {
              dispatch({
                type: PUT_REGS_TRACK_INT_AGENCY_FAILURE,
                json: text,
              });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .then((json) => {
        if (json) {
          dispatch({
            type: PUT_REGS_TRACK_INT_AGENCY_SUCCESS,
            payload: {
              json,
              arrayIndex,
            },
          });
          return json;
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({
          type: PUT_REGS_TRACK_INT_AGENCY_FAILURE,
          json: err.message,
        });
      });
  };
}

// End Regs Agencys/Agencies

export function addRegsUrlRecordToURLs(defaultUrl, defaultDesc) {
  return (dispatch) => {
    dispatch({ type: ADD_NEW_REGS_INFO_URL_RECORD, 
                payload: { defaultUrl, defaultDesc }, 
    });
    const url = defaultUrl ? { Url: defaultUrl, Description: defaultDesc } : null;
    dispatch(
      addInitialValue(
        pageIndex.regsTrackInternal,
        "regsUrls",
        matchRegsUrl(url)
      )
    );
  };
}

export function deleteRegsUrl(regsUrlId, recordInfo, arrayIndex) {
  return (dispatch) => {
    dispatch({ type: DELETE_REGS_TRACK_INT_URL_START });

    if (regsUrlId === -1) {
      dispatch(
        deleteInitialValueAt(
          {
            page: pageIndex.regsTrackInternal,
            field: "regsUrls",
          },
          arrayIndex
        )
      );

      return dispatch({
        type: DELETE_REGS_TRACK_INT_URL_SUCCESS,
        payload: {
          regsUrlId,
          recordInfo,
          arrayIndex,
        },
      });
    }

    const options = {
      method: "DELETE",
      credentials: "include",
    };

    const url = new URL(`${globals.apiUrl}/RegsTrackIntUrl/${regsUrlId}`);

    return fetch(url, options)
      .then((response) => {
        if (response.status === 204 || response.status === 200) {
          dispatch({
            type: DELETE_REGS_TRACK_INT_URL_SUCCESS,
            payload: {
              regsUrlId,
              recordInfo,
              arrayIndex,
            },
          });
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (
          response.status === 400 ||
          response.status === 404 ||
          response.status === 409 ||
          response.status === 500
        ) {
          response.text().then((text) => {
            if (text) {
              dispatch({ type: DELETE_REGS_TRACK_INT_URL_FAILURE, json: text });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({ type: DELETE_REGS_TRACK_INT_URL_FAILURE, json: err.message });
      });
  };
}

export function addRegsCitationRecordToCitations() {
  return (dispatch) => {
    dispatch({ type: ADD_NEW_REGS_INFO_CITATION_RECORD });
    dispatch(
      addInitialValue(
        pageIndex.regsTrackInternal,
        "regsCitations",
        matchRegsCitation()
      )
    );
  };
}

export function deleteRegsCitation(regsCitationId, recordInfo, arrayIndex) {
  return (dispatch) => {
    dispatch({ type: DELETE_REGS_TRACK_INT_CITATION_START });

    if (regsCitationId === -1) {
      dispatch(
        deleteInitialValueAt(
          {
            page: pageIndex.regsTrackInternal,
            field: "regsCitations",
          },
          arrayIndex
        )
      );

      return dispatch({
        type: DELETE_REGS_TRACK_INT_CITATION_SUCCESS,
        payload: {
          regsCitationId,
          recordInfo,
          arrayIndex,
        },
      });
    }

    const options = {
      method: "DELETE",
      credentials: "include",
    };

    const url = new URL(`${globals.apiUrl}/RegsTrackIntCitation/${regsCitationId}`);

    return fetch(url, options)
      .then((response) => {
        if (response.status === 204 || response.status === 200) {
          dispatch({
            type: DELETE_REGS_TRACK_INT_CITATION_SUCCESS,
            payload: {
              regsCitationId,
              recordInfo,
              arrayIndex,
            },
          });
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (
          response.status === 400 ||
          response.status === 404 ||
          response.status === 409 ||
          response.status === 500
        ) {
          response.text().then((text) => {
            if (text) {
              dispatch({ type: DELETE_REGS_TRACK_INT_CITATION_FAILURE, json: text });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({ type: DELETE_REGS_TRACK_INT_CITATION_FAILURE, json: err.message });
      });
  };
}

export function addRegsHistoryActionRecordToHistoryActions() {
  return (dispatch) => {
    dispatch({ type: ADD_NEW_REGS_INFO_HISTORYACTION_RECORD });
    dispatch(
      addInitialValue(
        pageIndex.regsTrackInternal,
        "regsHistoryActions",
        matchRegsHistoryAction()
      )
    );
  };
}

export function deleteRegsHistoryAction(regsHistoryId, recordInfo, arrayIndex) {
  return (dispatch) => {
    dispatch({ type: DELETE_REGS_TRACK_INT_HISTORYACTION_START });

    if (regsHistoryId === -1) {
      dispatch(
        deleteInitialValueAt(
          {
            page: pageIndex.regsTrackInternal,
            field: "regsHistoryActions",
          },
          arrayIndex
        )
      );

      return dispatch({
        type: DELETE_REGS_TRACK_INT_HISTORYACTION_SUCCESS,
        payload: {
          regsHistoryId,
          recordInfo,
          arrayIndex,
        },
      });
    }

    const options = {
      method: "DELETE",
      credentials: "include",
    };

    const url = new URL(`${globals.apiUrl}/RegsTrackIntHistory/${regsHistoryId}`);

    return fetch(url, options)
      .then((response) => {
        if (response.status === 204 || response.status === 200) {
          dispatch({
            type: DELETE_REGS_TRACK_INT_HISTORYACTION_SUCCESS,
            payload: {
              regsHistoryId,
              recordInfo,
              arrayIndex,
            },
          });
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (
          response.status === 400 ||
          response.status === 404 ||
          response.status === 409 ||
          response.status === 500
        ) {
          response.text().then((text) => {
            if (text) {
              dispatch({ type: DELETE_REGS_TRACK_INT_HISTORYACTION_FAILURE, json: text });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({ type: DELETE_REGS_TRACK_INT_HISTORYACTION_FAILURE, json: err.message });
      });
  };
}

export function addRegsAgencyRecordToAgencys() {
  return (dispatch) => {
    dispatch({ type: ADD_NEW_REGS_INFO_AGENCY_RECORD });
    dispatch(
      addInitialValue(
        pageIndex.regsTrackInternal,
        "regsAgencys",
        matchRegsAgencys()
      )
    );
  };
}

export function deleteRegsAgency(regsAgencyId, recordInfo, arrayIndex) {
  return (dispatch) => {
    dispatch({ type: DELETE_REGS_TRACK_INT_AGENCY_START });

    if (regsAgencyId === -1) {
      dispatch(
        deleteInitialValueAt(
          {
            page: pageIndex.regsTrackInternal,
            field: "regsAgencys",
          },
          arrayIndex
        )
      );

      return dispatch({
        type: DELETE_REGS_TRACK_INT_AGENCY_SUCCESS,
        payload: {
          regsAgencyId,
          recordInfo,
          arrayIndex,
        },
      });
    }

    const options = {
      method: "DELETE",
      credentials: "include",
    };

    const url = new URL(`${globals.apiUrl}/RegsTrackIntAgency/${regsAgencyId}`);

    return fetch(url, options)
      .then((response) => {
        if (response.status === 204 || response.status === 200) {
          dispatch({
            type: DELETE_REGS_TRACK_INT_AGENCY_SUCCESS,
            payload: {
              regsAgencyId,
              recordInfo,
              arrayIndex,
            },
          });
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (
          response.status === 400 ||
          response.status === 404 ||
          response.status === 409 ||
          response.status === 500
        ) {
          response.text().then((text) => {
            if (text) {
              dispatch({ type: DELETE_REGS_TRACK_INT_AGENCY_FAILURE, json: text });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({ type: DELETE_REGS_TRACK_INT_AGENCY_FAILURE, json: err.message });
      });
  };
}

export function deleteHistoryAction(regsHistoryId, recordInfo, arrayIndex) {
  return (dispatch) => {
    dispatch({ type: DELETE_REGS_INFO_HISTORY_START });

    if (regsHistoryId === -1) {
      dispatch(
        deleteInitialValueAt(
          {
            page: pageIndex.regsTrackInternal,
            field: "historyActions",
          },
          arrayIndex
        )
      );

      dispatch({
        type: DELETE_REGS_INFO_HISTORY_SUCCESS,
        payload: {
          regsHistoryId,
          recordInfo,
          arrayIndex,
        },
      });

      return;
    }

    const options = {
      method: "DELETE",
      credentials: "include",
    };

    const url = new URL(
      `${globals.apiUrl}/regstrackinthistory/${regsHistoryId}`
    );

    return fetch(url, options)
      .then((response) => {
        if (response.status === 204 || response.status === 200) {
          dispatch({
            type: DELETE_REGS_INFO_HISTORY_SUCCESS,
            payload: {
              regsHistoryId,
              arrayIndex,
            },
          });
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (
          response.status === 400 ||
          response.status === 404 ||
          response.status === 409 ||
          response.status === 500
        ) {
          response.text().then((text) => {
            if (text) {
              dispatch({ type: DELETE_REGS_INFO_HISTORY_FAILURE, json: text });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({ type: DELETE_REGS_INFO_HISTORY_FAILURE, json: err.message });
      });
  };
}

export function deleteClientSubjectTag(subjectId) {
  return (dispatch) => {
    dispatch({ type: DELETE_REGS_INFO_CLIENT_SUBJECT_TAG_START });

    const options = {
      method: "DELETE",
      credentials: "include",
    };

    const url = new URL(`${globals.apiUrl}/clientSubjectTag/${subjectId}`);

    return fetch(url, options)
      .then((response) => {
        if (response.status === 204 || response.status === 200) {
          dispatch({
            type: DELETE_REGS_INFO_CLIENT_SUBJECT_TAG_SUCCESS,
            payload: {
              subjectId,
            },
          });
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (
          response.status === 400 ||
          response.status === 404 ||
          response.status === 409 ||
          response.status === 500
        ) {
          response.text().then((text) => {
            if (text) {
              dispatch({
                type: DELETE_REGS_INFO_CLIENT_SUBJECT_TAG_FAILURE,
                json: text,
              });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({
          type: DELETE_REGS_INFO_CLIENT_SUBJECT_TAG_FAILURE,
          json: err.message,
        });
      });
  };
}

export function putClientSubjectTag(clientSubjectTag) {
  return (dispatch) => {
    dispatch({ type: PUT_REGS_INFO_CLIENT_SUBJECT_TAG_START });
    const options = {
      method: "Put",
      credentials: "include",
      headers,
      body: [JSON.stringify(clientSubjectTag)],
    };
    return fetch(`${globals.apiUrl}/clientSubjectTag`, options)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (response.status === 400) {
          response.text().then((text) => {
            if (text) {
              dispatch({
                type: PUT_REGS_INFO_CLIENT_SUBJECT_TAG_FAILURE,
                json: text,
              });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .then((json) => {
        if (json) {
          dispatch({
            type: PUT_REGS_INFO_CLIENT_SUBJECT_TAG_SUCCESS,
            payload: {
              json,
            },
          });

          return json;
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({
          type: PUT_REGS_INFO_CLIENT_SUBJECT_TAG_FAILURE,
          json: err.message,
        });
      });
  };
}

export function updateSubscribeDateForAll(recordId, dataType, subscribeDate) {
  return (dispatch) => {
    dispatch({ type: UPDATE_SUBSCRIBE_DATE_ALL_START });
    const options = {
      method: "Put",
      credentials: "include",
      headers,
      body: JSON.stringify({
        recordId,
        dataType,
        subscribeDate,
      }),
    };
    return fetch(`${globals.apiUrl}/ClientSubjectSubscription`, options)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (response.status === 400) {
          response.text().then((text) => {
            if (text) {
              dispatch({
                type: UPDATE_SUBSCRIBE_DATE_ALL_FAILURE,
                json: text,
              });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .then((json) => {
        if (json) {
          dispatch({
            type: UPDATE_SUBSCRIBE_DATE_ALL_SUCCESS,
            payload: {
              json,
            },
          });
          return true;
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({
          type: UPDATE_SUBSCRIBE_DATE_ALL_FAILURE,
          json: err.message,
        });
      });
  };
}

export function putRegsHistory(historyData) {
  return (dispatch) => {
    dispatch({ type: PUT_REGS_INFO_HISTORY_START });
    const options = {
      method: "Put",
      credentials: "include",
      headers,
      body: JSON.stringify(historyData),
    };

    return fetch(`${globals.apiUrl}/regstrackinthistory`, options)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (response.status === 400 || response.status === 409) {
          response.text().then((text) => {
            if (text) {
              dispatch({
                type: PUT_REGS_INFO_HISTORY_FAILURE,
                json: text,
              });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .then((json) => {
        if (json) {
          dispatch({
            type: PUT_REGS_INFO_HISTORY_SUCCESS,
            payload: {
              json,
            },
          });

          return json;
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({
          type: PUT_REGS_INFO_HISTORY_FAILURE,
          json: err.message,
        });
      });
  };
}

export function getRegsHistoryLog(id) {
  return (dispatch) => {
    dispatch({ type: GET_REGS_INFO_HISTORY_LOG_START });
    const options = {
      method: "GET",
      credentials: "include",
    };

    const url = new URL(`${globals.apiUrl}/HistoryLog`);

    const params = {
      entityType: "regsid",
      entityId: id,
    };

    if (Object.keys(params)) {
      Object.keys(params).forEach((key) => {
        if (params[key]) {
          url.searchParams.append(key, params[key]);
        }
      });
    }

    return fetch(url, options)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (response.status === 400) {
          response.text().then((text) => {
            if (text) {
              dispatch({ type: GET_REGS_INFO_HISTORY_LOG_FAILURE, json: text });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .then((json) => {
        if (json) {
          dispatch({
            type: GET_REGS_INFO_HISTORY_LOG_SUCCESS,
            payload: {
              json,
            },
          });
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({ type: GET_REGS_INFO_HISTORY_LOG_FAILURE, json: err.message });
      });
  };
}

export function addManagementComment(
  recordId,
  team,
  comment,
  lateTagRequest,
  missedBill
) {
  return (dispatch) => {
    dispatch({ type: ADD_REGS_INFO_MANAGMENT_COMMENT_START });

    const options = {
      method: "POST",
      credentials: "include",
      headers,
      body: JSON.stringify({
        recordId,
        DataType: "regs",
        TeamAssigned: team,
        comment,
        lateTagRequest,
        missedBill,
      }),
    };

    return fetch(`${globals.apiUrl}/managementcomments`, options)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (response.status === 400 || response.status === 409) {
          response.text().then((text) => {
            if (text) {
              dispatch({
                type: ADD_REGS_INFO_MANAGMENT_COMMENT_FAILURE,
                json: text,
              });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .then((json) => {
        if (json) {
          dispatch({
            type: ADD_REGS_INFO_MANAGMENT_COMMENT_SUCCESS,
            payload: {
              json,
            },
          });

          return json;
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({
          type: ADD_REGS_INFO_MANAGMENT_COMMENT_FAILURE,
          json: err.message,
        });
      });
  };
}

export function sendAlertHistoryLog(entityId, activityDescription) {
  return (dispatch) => {
    dispatch({ type: ADD_SENDALERT_HISTORY_LOG_START });

    const options = {
      method: "POST",
      credentials: "include",
      headers,
      body: JSON.stringify({
        entityType: "RegsId",
        workItemLocation: "RegsTrack",
        entityId,
        activityDescription,
      }),
    };

    return fetch(`${globals.apiUrl}/HistoryLog`, options)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (response.status === 400 || response.status === 409) {
          response.text().then((text) => {
            if (text) {
              dispatch({
                type: ADD_SENDALERT_HISTORY_LOG_FAILURE,
                json: text,
              });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .then((json) => {
        if (json) {
          dispatch({
            type: ADD_SENDALERT_HISTORY_LOG_SUCCESS,
            payload: {
              json,
            },
          });

          return json;
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({
          type: ADD_SENDALERT_HISTORY_LOG_FAILURE,
          json: err.message,
        });
      });
  };
}

export function updateManagementComment(managementComment) {
  return (dispatch) => {
    dispatch({ type: PUT_REGS_INFO_MANAGEMENT_COMMENT_START });
    const options = {
      method: "Put",
      credentials: "include",
      headers,
      body: JSON.stringify(managementComment),
    };

    return fetch(`${globals.apiUrl}/managementcomments`, options)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (response.status === 400 || response.status === 409) {
          response.text().then((text) => {
            if (text) {
              dispatch({
                type: PUT_REGS_INFO_MANAGEMENT_COMMENT_FAILURE,
                json: text,
              });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .then((json) => {
        if (json) {
          dispatch({
            type: PUT_REGS_INFO_MANAGEMENT_COMMENT_SUCCESS,
            payload: {
              json,
            },
          });

          return json;
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({
          type: PUT_REGS_INFO_MANAGEMENT_COMMENT_FAILURE,
          json: err.message,
        });
      });
  };
}

export function getRegsTagComparison(primaryRegsId, companionRegsId) {
  return (dispatch) => {
    dispatch({ type: GET_REGS_INFO_TAG_COMPARISON_START });

    const options = {
      method: "GET",
      credentials: "include",
    };

    const url = new URL(`${globals.apiUrl}/RegsTagComparison`);

    const params = {
      primaryRegsId,
      companionRegsId,
    };

    if (Object.keys(params)) {
      Object.keys(params).forEach((key) => {
        if (params[key]) {
          url.searchParams.append(key, params[key]);
        }
      });
    }

    return fetch(url, options)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (response.status === 400) {
          response.text().then((text) => {
            if (text) {
              dispatch({
                type: GET_REGS_INFO_TAG_COMPARISON_FAILURE,
                json: text,
              });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .then((json) => {
        if (json) {
          dispatch({
            type: GET_REGS_INFO_TAG_COMPARISON_SUCCESS,
            payload: {
              json,
            },
          });
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({
          type: GET_REGS_INFO_TAG_COMPARISON_FAILURE,
          json: err.message,
        });
      });
  };
}

export function putCompanionBillReview(regsId, team, reviewed) {
  return (dispatch) => {
    dispatch({ type: PUT_COMPANION_BILL_REVIEW_START });

    const options = {
      method: "Put",
      credentials: "include",
      headers,
      body: JSON.stringify({
        RegsId: regsId,
        Reviews: [{ TeamGroupId: team, Reviewed: reviewed }],
      }),
    };

    return fetch(`${globals.apiUrl}/CompanionBillReview`, options)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (response.status === 400) {
          response.text().then((text) => {
            if (text) {
              dispatch({
                type: PUT_COMPANION_BILL_REVIEW_FAILURE,
                json: text,
              });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .then((json) => {
        if (json) {
          dispatch({
            type: PUT_COMPANION_BILL_REVIEW_SUCCESS,
            payload: {
              json,
            },
          });
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({
          type: PUT_COMPANION_BILL_REVIEW_FAILURE,
          json: err.message,
        });
      });
  };
}

export function uploadUrl(
  recordId,
  uploadFile,
  recordType,
  description,
  page,
  arrayIndex
) {
  return (dispatch) => {
    dispatch({ type: UPLOAD_DOCUMENT_START });

    const formData = new FormData();

    formData.append("Description", description);
    formData.append("RecId", recordId);
    formData.append("RecType", recordType);
    formData.append("UploadedFile", uploadFile);
    formData.append("PageNumber", page);

    const options = {
      method: "POST",
      credentials: "include",
      body: formData,
    };

    return fetch(`${globals.apiUrl}/document`, options)
      .then((response) => {
        if (response.redirected) {
          return { type: "url", url: response.url };
        }

        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (response.status === 400 || response.status === 409) {
          response.text().then((text) => {
            if (text) {
              dispatch({
                type: UPLOAD_DOCUMENT_FAILURE,
                json: text,
              });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .then((json) => {
        if (json) {
          dispatch({
            type: POST_REGS_TRACK_INT_URL_SUCCESS,
            payload: {
              json,
              arrayIndex,
            },
          });

          return json;
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({
          type: UPLOAD_DOCUMENT_FAILURE,
          json: "Uploading document: " + err.message,
        });
        dispatch(showModal("Error"));
      });
  };
}

export function clearFormFields() {
  return {
    type: CLEAR_REGS_TRACK_FIELD_FOR_NO_RESULTS,
  };
}

export function returnInitialState() {
  return {
    type: RETURN_REGS_TRACK_INITIAL_STATE,
  };
}

function moveUrlOrder(urlIndex, regsUrls, direction) {
  const regsUrlCurrent = {
    ...regsUrls[urlIndex],
    textValues: {
      ...regsUrls[urlIndex].textValues,
      SortOrder: regsUrls[urlIndex].textValues.SortOrder - direction,
    },
  };

  const regsUrlNext = {
    ...regsUrls[urlIndex - direction],
    textValues: {
      ...regsUrls[urlIndex - direction].textValues,
      SortOrder:
        regsUrls[urlIndex - direction].textValues.SortOrder + direction,
    },
  };

  const newRegsUrls = Object.assign([], regsUrls, {
    [urlIndex]: regsUrlCurrent,
    [urlIndex - direction]: regsUrlNext,
  }).sort((a, b) => a.textValues.SortOrder - b.textValues.SortOrder);

  return { regsUrlCurrent, regsUrlNext, newRegsUrls };
}

function moveAgencyOrder(agencyIndex, regsAgencys, direction) {
  const regsAgencyCurrent = {
    ...regsAgencys[agencyIndex],
    textValues: {
      ...regsAgencys[agencyIndex].textValues,
      SortOrder: regsAgencys[agencyIndex].textValues.SortOrder - direction,
    },
  };

  const regsAgencyNext = {
    ...regsAgencys[agencyIndex - direction],
    textValues: {
      ...regsAgencys[agencyIndex - direction].textValues,
      SortOrder:
        regsAgencys[agencyIndex - direction].textValues.SortOrder + direction,
    },
  };

  const newRegsAgency = Object.assign([], regsAgencys, {
    [agencyIndex]: regsAgencyCurrent,
    [agencyIndex - direction]: regsAgencyNext,
  }).sort((a, b) => a.textValues.SortOrder - b.textValues.SortOrder);

  return { regsAgencyCurrent, regsAgencyNext, newRegsAgency };
}

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [UPDATE_DATA]: (state, action) =>
    action.location.page !== pageIndex.regsTrackInternal
      ? state
      : actionHandler(state, action),
  [RETURN_REGS_TRACK_INITIAL_STATE]: () => {
    return {
      ...initialState,
    };
  },
  [GET_REGS_TRACK_INT_QUERY_DATA_START]: (state) => {
    return {
      ...state,
      isFetchingData: true,
    };
  },
  [GET_REGS_TRACK_INT_QUERY_DATA_SUCCESS]: (state, action) => {
    const { json } = action.payload;
    return {
      ...state,
      renderData: {
        ...state.renderData,
        queriesWithParameters: json,
        queries: json.map((item) => {
          return {
            value: item.QueryId,
            label: item.QueryName,
          };
        }),
      },
    };
  },
  [UPDATE_REGS_INFO_URLS]: (state, action) => {
    return {
      ...state,
      formDataValue: {
        ...state.formDataValue,
        RTI: {
          ...state.formDataValue.RTI,
          regsUrls: action.newRegsUrls,
        },
      },
    };
  },
  [POST_REGS_INFO_START]: (state) => {
    return {
      ...state,
      //isFetchingData: true,
    };
  },
  [POST_REGS_INFO_FAILURE]: (state, action) => {
    return {
      ...state,
      errorCode: action.json,
      isFetchingData: false,
      isError: true,
    };
  },
  [POST_REGS_INFO_SUCCESS]: (state) => {
    // const baseRecordInfo = action.payload.baseRecordInfo;
    // const recordCreated =
    //   state.formDataValue.RTI.recordInfo.textValues.recordCreated;
    // const reviewers = state.formDataValue.RTI.recordInfo.textValues.reviewers;

    // const recordInfo = combineRecordInfo(
    //   baseRecordInfo,
    //   recordCreated,
    //   reviewers
    // );

    // return {
    //   ...state,
    //   formDataValue: {
    //     ...state.formDataValue,
    //     RTI: {
    //       ...state.formDataValue.RTI,
    //       recordInfo,
    //     },
    //   },
    // };
    return {
      ...state,
    };
  },
  [PUT_REGS_INFO_START]: (state) => {
    return {
      ...state,
      //isFetchingData: true,
    };
  },
  [PUT_REGS_INFO_FAILURE]: (state, action) => {
    return {
      ...state,
      errorCode: action.json,
      isFetchingData: false,
      isError: true,
    };
  },
  [PUT_REGS_INFO_SUCCESS]: (state, action) => {
    const baseRecordInfo = action.payload.baseRecordInfo;
    const recordCreated =
      state.formDataValue.RTI.recordInfo.textValues.recordCreated;
    const reviewers = state.formDataValue.RTI.recordInfo.textValues.reviewers;

    const recordInfo = combineRecordInfo(
      baseRecordInfo,
      recordCreated,
      reviewers
    );
    return {
      ...state,
      formDataValue: {
        ...state.formDataValue,
        RTI: {
          ...state.formDataValue.RTI,
          recordInfo,
        },
      },
    };
  },
  [GET_ALL_REGIONS_FETCHED]: (state, action) => {
    return {
      ...state,
      renderData: {
        ...state.renderData,
        regions: action.payload.json.map((item) => {
          return {            
            value: item.Name,
            label: item.Name,
            shortName: item.ShortName,
          };
        }).filter((elem) => {
          return elem.label !== "All States" 
            && elem.label !== "Canada"
            && elem.label !== "Spain"
        }),
      },
    };
  },

  [PUT_REGS_INFO_HISTORY_START]: (state) => {
    return {
      ...state,
      //isFetchingData: true,
    };
  },
  [PUT_REGS_INFO_HISTORY_FAILURE]: (state, action) => {
    return {
      ...state,
      errorCode: action.json,
      isFetchingData: false,
      isError: true,
    };
  },
  [PUT_REGS_INFO_HISTORY_SUCCESS]: (state, action) => {
    const newHistoryAction = action.payload.json;

    const historyActionIndex =
      state.formDataValue.RTI.historyActions.findIndex(
        (historyAction) =>
          historyAction.textValues.RegsHistoryId ===
          newHistoryAction.RegsHistoryId
      );

    const newState = {
      ...state,
      formDataValue: {
        ...state.formDataValue,
        RTI: {
          ...state.formDataValue.RTI,
          historyActions: Object.assign(
            [],
            state.formDataValue.RTI.historyActions,
            {
              [historyActionIndex]: matchHistoryAction(newHistoryAction),
            }
          ),
        },
      },
    };

    return newState;
  },
  [PUT_REGS_INFO_MANAGEMENT_COMMENT_START]: (state) => {
    return {
      ...state,
      //isFetchingData: true,
    };
  },
  [PUT_REGS_INFO_MANAGEMENT_COMMENT_FAILURE]: (state, action) => {
    return {
      ...state,
      errorCode: action.json,
      isFetchingData: false,
      isError: true,
    };
  },
  [PUT_REGS_INFO_MANAGEMENT_COMMENT_SUCCESS]: (state, action) => {
    const newManagementComment = action.payload.json;

    const commentIndex = state.formDataValue.RTI.managementComments.findIndex(
      (managementComment) =>
        managementComment.textValues.Id === newManagementComment.Id
    );

    return {
      ...state,
      formDataValue: {
        ...state.formDataValue,
        RTI: {
          ...state.formDataValue.RTI,
          managementComments: Object.assign(
            [],
            state.formDataValue.RTI.managementComments,
            {
              [commentIndex]: matchManagementComment(newManagementComment),
            }
          ),
        },
      },
    };
  },
  [ADD_SENDALERT_HISTORY_LOG_FAILURE]: (state, action) => {
    return {
      ...state,
      errorCode: action.json,
      isFetchingData: false,
      isError: true,
    };
  },
  [PUT_REGS_INFO_CLIENT_SUBJECT_TAG_FAILURE]: (state, action) => {
    return {
      ...state,
      errorCode: action.json,
      isFetchingData: false,
      isError: true,
    };
  },
  [UPDATE_SUBSCRIBE_DATE_ALL_START]: (state) => {
    return {
      ...state,
      //isFetchingData: true,
    };
  },
  [UPDATE_SUBSCRIBE_DATE_ALL_FAILURE]: (state, action) => {
    return {
      ...state,
      errorCode: action.json,
      isFetchingData: false,
      isError: true,
    };
  },
  [UPDATE_SUBSCRIBE_DATE_ALL_SUCCESS]: (state, action) => {
    const clientSubjectTags = matchClientSubjectTags(action.payload.json);

    return {
      ...state,
      formDataValue: {
        ...state.formDataValue,
        RTI: {
          ...state.formDataValue.RTI,
          clientSubjectTags,
        },
      },
    };
  },
  [PUT_REGS_INFO_CLIENT_SUBJECT_TAG_START]: (state) => {
    return {
      ...state,
      //isFetchingData: true,
    };
  },
  [PUT_REGS_INFO_CLIENT_SUBJECT_TAG_FAILURE]: (state, action) => {
    return {
      ...state,
      errorCode: action.json,
      isFetchingData: false,
      isError: true,
    };
  },
  [PUT_REGS_INFO_CLIENT_SUBJECT_TAG_SUCCESS]: (state, action) => {
    const newCientSubjectTag = action.payload.json;

    const tageIndex = state.formDataValue.RTI.clientSubjectTags.findIndex(
      (clientSubjectTag) =>
        clientSubjectTag.SubjectId === newCientSubjectTag.SubjectId
    );

    return {
      ...state,
      formDataValue: {
        ...state.formDataValue,
        RTI: {
          ...state.formDataValue.RTI,
          clientSubjectTags: Object.assign(
            [],
            state.formDataValue.RTI.clientSubjectTags,
            {
              [tageIndex]: matchClientSubjectTag(newCientSubjectTag),
            }
          ),
        },
      },
    };
  },
  [PUT_CLIENT_ACTION_COMMENT_START]: (state) => {
    return {
      ...state,
      //isFetchingData: true,
    };
  },
  [PUT_CLIENT_ACTION_COMMENT_FAILURE]: (state, action) => {
    return {
      ...state,
      errorCode: action.json,
      isFetchingData: false,
      isError: true,
    };
  },
  [PUT_CLIENT_ACTION_COMMENT_SUCCESS]: (state, action) => {
    //return clientActionSuccess(action, state);
    const { json, arrayIndex } = action.payload;
    return {
      ...state,
      clientActionsUpdating: false,
      formDataValue: {
        ...state.formDataValue,
        RTI: {
          ...state.formDataValue.RTI,
          clientActions: Object.values({
            ...state.formDataValue.RTI.clientActions,
            [arrayIndex]: matchClientAction(json),
          }),
        },
      },
    };    
  },

  [PUT_CLIENT_ACTION_START]: (state) => {
    return {
      ...state,
      //isFetchingData: true,
    };
  },
  [PUT_CLIENT_ACTION_FAILURE]: (state, action) => {
    return {
      ...state,
      errorCode: action.json,
      isFetchingData: false,
      isError: true,
    };
  },
  [PUT_CLIENT_ACTION_SUCCESS]: (state, action) => {
    return clientActionSuccess(action, state);
  },
  [POST_REGS_TRACK_DATA_START]: (state) => {
    return {
      ...state,
      isFetchingData: true,
    };
  },
  [POST_REGS_TRACK_DATA_SUCCESS]: (state, action) => {
    const queryRecords = action.payload.json;
    return {
      ...state,
      renderData: {
        ...state.renderData,
        queryRecords,
      },
    };
  },
  [POST_REGS_TRACK_DATA_FAILURE]: (state, action) => {
    return {
      ...state,
      errorCode: action.json,
      isFetchingData: false,
      isError: true,
    };
  },
  [GET_REGS_TRACK_TEAM_REVIEW_DATA_START]: (state) => {
    return {
      ...state,
    };
  },
  [GET_REGS_TRACK_TEAM_REVIEW_DATA_SUCCESS]: (state, action) => {
    const recordsData = action.payload.json;
    return {
      ...state,
      formDataValue: {
        ...state.formDataValue,
        RTI: {
          ...state.formDataValue.RTI,
          reviewRecords: matchReviewRows(recordsData),
        },
      },
    };
  },
  [GET_REGS_TRACK_TEAM_REVIEW_DATA_FAILURE]: (state, action) => {
    return {
      ...state,
      errorCode: action.json,
      isError: true,
    };
  },
  [SET_REGS_TRACK_TEAMS_REVIEW_DATA_START]: (state) => {
    return {
      ...state,
    };
  },
  [SET_REGS_TRACK_TEAMS_REVIEW_DATA_SUCCESS]: (state, action) => {
    const recordsData = action.payload.json;
    return {
      ...state,
      formDataValue: {
        ...state.formDataValue,
        RTI: {
          ...state.formDataValue.RTI,
          reviewRecords: matchReviewRows(recordsData),
        },
      },
    };
  },
  [SET_REGS_TRACK_TEAMS_REVIEW_DATA_FAILURE]: (state, action) => {
    return {
      ...state,
      errorCode: action.json,
      isError: true,
    };
  },
  [DELETE_REGS_INFO_DOC_START]: (state) => {
    return {
      ...state,
    };
  },
  [DELETE_REGS_INFO_DOC_FAILURE]: (state, action) => {
    return {
      ...state,
      errorCode: action.json,
      isError: true,
    };
  },
  [DELETE_REGS_INFO_DOC_SUCCESS]: (state, action) => {
    const { docId } = action.payload;
    return {
      ...state,
      formDataValue: {
        ...state.formDataValue,
        RTI: {
          ...state.formDataValue.RTI,
          documents: state.formDataValue.RTI.documents.filter(
            (doc) => doc.id !== docId
          ),
        },
      },
    };
  },
  [ADD_NEW_REGS_INFO_URL_RECORD]: (state, action) => {
    const { defaultUrl, defaultDesc } = action.payload;
    let url = null;
    if (defaultUrl) url = { Url: defaultUrl, Description: defaultDesc };
    const newRegsUrls = [
      matchRegsUrl(url),
      ...state.formDataValue.RTI.regsUrls,
    ];
    return {
      ...state,
      formDataValue: {
        ...state.formDataValue,
        RTI: {
          ...state.formDataValue.RTI,
          regsUrls: newRegsUrls,
        },
      },
    };
  },
  [DELETE_REGS_TRACK_INT_URL_START]: (state) => {
    return {
      ...state,
    };
  },
  [DELETE_REGS_TRACK_INT_URL_FAILURE]: (state, action) => {
    return {
      ...state,
      errorCode: action.json,
      isError: true,
    };
  },
  [DELETE_REGS_TRACK_INT_URL_SUCCESS]: (state, action) => {
    const { arrayIndex } = action.payload;
    const newRegsUrls = [...state.formDataValue.RTI.regsUrls];
    newRegsUrls.splice(arrayIndex, 1);

    return {
      ...state,
      formDataValue: {
        ...state.formDataValue,
        RTI: {
          ...state.formDataValue.RTI,
          regsUrls: newRegsUrls,
        },
      },
    };
  },
  // Citations 
  [ADD_NEW_REGS_INFO_CITATION_RECORD]: (state) => {
    const newRegsCitations = [
      matchRegsCitation(),
      ...state.formDataValue.RTI.regsCitations,
    ];
    return {
      ...state,
      formDataValue: {
        ...state.formDataValue,
        RTI: {
          ...state.formDataValue.RTI,
          regsCitations: newRegsCitations,
        },
      },
    };
  },
  [DELETE_REGS_TRACK_INT_CITATION_START]: (state) => {
    return {
      ...state,
    };
  },
  [DELETE_REGS_TRACK_INT_CITATION_FAILURE]: (state, action) => {
    return {
      ...state,
      errorCode: action.json,
      isError: true,
    };
  },
  [DELETE_REGS_TRACK_INT_CITATION_SUCCESS]: (state, action) => {
    const { arrayIndex } = action.payload;
    const newRegsCitations = [...state.formDataValue.RTI.regsCitations];
    newRegsCitations.splice(arrayIndex, 1);

    return {
      ...state,
      formDataValue: {
        ...state.formDataValue,
        RTI: {
          ...state.formDataValue.RTI,
          regsCitations: newRegsCitations,
        },
      },
    };
  },
  // End Citations
  // SET RunRules value
  [SET_RUNRULES_TRUE]: (state) => {
    return {
      ...state,
      formDataValue: {
        ...state.formDataValue,
        RTI: {
          ...state.formDataValue.RTI,
          regsHistoryRunRules: true,
        },
      },
    };
  },
  [SET_RUNRULES_FALSE]: (state) => {
    return {
      ...state,
      formDataValue: {
        ...state.formDataValue,
        RTI: {
          ...state.formDataValue.RTI,
          regsHistoryRunRules: false,
        },
      },
    };
  },
  // End RUNRULES 
  // HistoryActions 
  [ADD_NEW_REGS_INFO_HISTORYACTION_RECORD]: (state) => {
    const newRegsHistoryActions = [
      matchRegsHistoryAction(),
      ...state.formDataValue.RTI.regsHistoryActions,
    ];
    return {
      ...state,
      formDataValue: {
        ...state.formDataValue,
        RTI: {
          ...state.formDataValue.RTI,
          regsHistoryActions: newRegsHistoryActions,
        },
      },
    };
  },
  [DELETE_REGS_TRACK_INT_HISTORYACTION_START]: (state) => {
    return {
      ...state,
    };
  },
  [DELETE_REGS_TRACK_INT_HISTORYACTION_FAILURE]: (state, action) => {
    return {
      ...state,
      errorCode: action.json,
      isError: true,
    };
  },
  [DELETE_REGS_TRACK_INT_HISTORYACTION_SUCCESS]: (state, action) => {
    const { arrayIndex } = action.payload;
    const newRegsHistoryActions = [...state.formDataValue.RTI.regsHistoryActions];
    newRegsHistoryActions.splice(arrayIndex, 1);

    return {
      ...state,
      formDataValue: {
        ...state.formDataValue,
        RTI: {
          ...state.formDataValue.RTI,
          regsHistoryActions: newRegsHistoryActions,
        },
      },
    };
  },
  // End HistoryActions
  // Start Agency/Agencies
  [ADD_NEW_REGS_INFO_AGENCY_RECORD]: (state) => {
    const newRegsAgencys = [
      matchRegsAgency(),
      ...state.formDataValue.RTI.regsAgencys,
    ];
    return {
      ...state,
      formDataValue: {
        ...state.formDataValue,
        RTI: {
          ...state.formDataValue.RTI,
          regsAgencys: newRegsAgencys,
        },
      },
    };
  },
  [DELETE_REGS_TRACK_INT_AGENCY_START]: (state) => {
    return {
      ...state,
    };
  },
  [DELETE_REGS_TRACK_INT_AGENCY_FAILURE]: (state, action) => {
    return {
      ...state,
      errorCode: action.json,
      isError: true,
    };
  },
  [DELETE_REGS_TRACK_INT_AGENCY_SUCCESS]: (state, action) => {
    const { arrayIndex } = action.payload;
    const newRegsAgencys = [...state.formDataValue.RTI.regsAgencys];
    newRegsAgencys.splice(arrayIndex, 1);

    return {
      ...state,
      formDataValue: {
        ...state.formDataValue,
        RTI: {
          ...state.formDataValue.RTI,
          regsAgencys: newRegsAgencys,
        },
      },
    };
  },
  // End Agency/Agencies
  [DELETE_REGS_INFO_HISTORY_START]: (state) => {
    return {
      ...state,
    };
  },
  [DELETE_REGS_INFO_HISTORY_FAILURE]: (state, action) => {
    return {
      ...state,
      errorCode: action.json,
      isError: true,
    };
  },
  [DELETE_REGS_INFO_HISTORY_SUCCESS]: (state, action) => {
    const { arrayIndex } = action.payload;
    const newHistoryActions = [...state.formDataValue.RTI.historyActions];
    newHistoryActions.splice(arrayIndex, 1);

    return {
      ...state,
      formDataValue: {
        ...state.formDataValue,
        RTI: {
          ...state.formDataValue.RTI,
          historyActions: newHistoryActions,
        },
      },
    };
  },
  [FLIP_REGS_INFO_RECORD_LOCK_LOAD_DATE]: (state) => {
    return {
      ...state,
      lockLoadDate: !state.lockLoadDate,
    };
  },
  [DELETE_REGS_INFO_RECORD_START]: (state) => {
    return {
      ...state,
    };
  },
  [DELETE_REGS_INFO_RECORD_FAILURE]: (state, action) => {
    return {
      ...state,
      errorCode: action.json,
      isError: true,
    };
  },
  [DELETE_REGS_INFO_RECORD_SUCCESS]: (state, action) => {
    const { regsId } = action.payload;
    const queryRecords = state.renderData.queryRecords.filter(
      (id) => id !== regsId
    );

    return {
      ...state,
      renderData: {
        ...state.renderData,
        queryRecords,
      },
    };
  },
  [DELETE_REGS_INFO_CLIENT_SUBJECT_TAG_START]: (state) => {
    return {
      ...state,
    };
  },
  [DELETE_REGS_INFO_CLIENT_SUBJECT_TAG_FAILURE]: (state, action) => {
    return {
      ...state,
      errorCode: action.json,
      isError: true,
    };
  },
  [DELETE_REGS_INFO_CLIENT_SUBJECT_TAG_SUCCESS]: (state, action) => {
    const { subjectId } = action.payload;
    const newClientSubjectTags = [
      ...state.formDataValue.RTI.clientSubjectTags,
    ];
    const changingClientSubjectTag = newClientSubjectTags.find(
      (clientSubjectTag) => clientSubjectTag.SubjectId === subjectId
    );

    changingClientSubjectTag.Deleted = true;
    changingClientSubjectTag.DeletedByAnalyst = true;

    return {
      ...state,
      formDataValue: {
        ...state.formDataValue,
        RTI: {
          ...state.formDataValue.RTI,
          clientSubjectTags: newClientSubjectTags,
        },
      },
    };
  },
  // Regs URLs 
  [PUT_REGS_TRACK_INT_URL_START]: (state) => {
    return {
      ...state,
      regsUrlUpdating: true,
    };
  },
  [PUT_REGS_TRACK_INT_URL_FAILURE]: (state, action) => {
    return {
      ...state,
      errorCode: action.json,
      regsUrlUpdating: false,
      isError: true,
    };
  },
  [PUT_REGS_TRACK_INT_URL_SUCCESS]: (state, action) => {
    const { json, arrayIndex } = action.payload;
    return {
      ...state,
      regsUrlUpdating: false,
      formDataValue: {
        ...state.formDataValue,
        RTI: {
          ...state.formDataValue.RTI,
          regsUrls: Object.values({
            ...state.formDataValue.RTI.regsUrls,
            [arrayIndex]: matchRegsUrl(json),
          }),
        },
      },
    };
  },
  // Citations
  [PUT_REGS_TRACK_INT_CITATION_START]: (state) => {
    return {
      ...state,
      regsCitationUpdating: true,
    };
  },
  [PUT_REGS_TRACK_INT_CITATION_FAILURE]: (state, action) => {
    return {
      ...state,
      errorCode: action.json,
      regsCitationUpdating: false,
      isError: true,
    };
  },
  [PUT_REGS_TRACK_INT_CITATION_SUCCESS]: (state, action) => {
    const { json, arrayIndex } = action.payload;
    return {
      ...state,
      regsCitationUpdating: false,
      formDataValue: {
        ...state.formDataValue,
        RTI: {
          ...state.formDataValue.RTI,
          regsCitations: Object.values({
            ...state.formDataValue.RTI.regsCitations,
            [arrayIndex]: matchRegsCitation(json),
          }),
        },
      },
    };
  },
  // End Citations
  // Agencys (Agencies)
  [PUT_REGS_TRACK_INT_AGENCY_START]: (state) => {
    return {
      ...state,
      regsAgencyUpdating: true,
    };
  },
  [PUT_REGS_TRACK_INT_AGENCY_FAILURE]: (state, action) => {
    return {
      ...state,
      errorCode: action.json,
      regsAgencyUpdating: false,
      isError: true,
    };
  },
  [PUT_REGS_TRACK_INT_AGENCY_SUCCESS]: (state, action) => {
    const { json, arrayIndex } = action.payload;
    return {
      ...state,
      regsAgencyUpdating: false,
      formDataValue: {
        ...state.formDataValue,
        RTI: {
          ...state.formDataValue.RTI,
          regsAgencys: Object.values({
            ...state.formDataValue.RTI.regsAgencys,
            [arrayIndex]: matchRegsAgency(json),
          }),
        },
      },
    };
  },
  // End Agency (Agencies)
  // History Actions
  [PUT_REGS_TRACK_INT_HISTORYACTION_START]: (state) => {
    return {
      ...state,
    };
  },
  [PUT_REGS_TRACK_INT_HISTORYACTION_FAILURE]: (state, action) => {
    return {
      ...state,
      errorCode: action.json,
      isError: true,
    };
  },
  [PUT_REGS_TRACK_INT_HISTORYACTION_SUCCESS]: (state, action) => {
    const { json, arrayIndex } = action.payload;
    return {
      ...state,
      formDataValue: {
        ...state.formDataValue,
        RTI: {
          ...state.formDataValue.RTI,
          regsHistoryActions: Object.values({
            ...state.formDataValue.RTI.regsHistoryActions,
            [arrayIndex]: matchRegsHistoryAction(json),
          }),
        },
      },
    };
  },
  // End History Actions
  [ADD_REGS_INFO_DOC_START]: (state) => {
    return {
      ...state,
    };
  },
  [ADD_REGS_INFO_DOC_FAILURE]: (state, action) => {
    return {
      ...state,
      errorCode: action.json,
      isError: true,
    };
  },
  [ADD_REGS_INFO_DOC_SUCCESS]: (state, action) => {
    const { json } = action.payload;
    const newDocument = matchDocuments([json]);
    const newDocuments = [
      ...state.formDataValue.RTI.documents,
      ...newDocument,
    ];
    return {
      ...state,
      formDataValue: {
        ...state.formDataValue,
        RTI: {
          ...state.formDataValue.RTI,
          documents: newDocuments,
        },
      },
    };
  },
  // SiteURLs
  [POST_REGS_TRACK_INT_URL_START]: (state) => {
    return {
      ...state,
    };
  },
  [POST_REGS_TRACK_INT_URL_FAILURE]: (state, action) => {
    return {
      ...state,
      errorCode: action.json,
      isError: true,
    };
  },
  [POST_REGS_TRACK_INT_URL_SUCCESS]: (state, action) => {
    const { json, arrayIndex } = action.payload;
    return {
      ...state,
      formDataValue: {
        ...state.formDataValue,
        RTI: {
          ...state.formDataValue.RTI,
          regsUrls: Object.values({
            ...state.formDataValue.RTI.regsUrls,
            [arrayIndex]: matchRegsUrl(json),
          }),
        },
      },
    };
  },
  // Citations
  [POST_REGS_TRACK_INT_CITATION_START]: (state) => {
    return {
      ...state,
    };
  },
  [POST_REGS_TRACK_INT_CITATION_FAILURE]: (state, action) => {
    return {
      ...state,
      errorCode: action.json,
      isError: true,
    };
  },
  [POST_REGS_TRACK_INT_CITATION_SUCCESS]: (state, action) => {
    const { json, arrayIndex } = action.payload;
    return {
      ...state,
      formDataValue: {
        ...state.formDataValue,
        RTI: {
          ...state.formDataValue.RTI,
          regsCitations: Object.values({
            ...state.formDataValue.RTI.regsCitations,
            [arrayIndex]: matchRegsCitation(json),
          }),
        },
      },
    };
  },
  // HistoryActions
  [POST_REGS_TRACK_INT_HISTORYACTION_START]: (state) => {
    return {
      ...state,
    };
  },
  [POST_REGS_TRACK_INT_HISTORYACTION_FAILURE]: (state, action) => {
    return {
      ...state,
      errorCode: action.json,
      isError: true,
    };
  },
  [POST_REGS_TRACK_INT_HISTORYACTION_SUCCESS]: (state, action) => {
    const { json, arrayIndex } = action.payload;
    return {
      ...state,
      formDataValue: {
        ...state.formDataValue,
        RTI: {
          ...state.formDataValue.RTI,
          regsHistoryActions: Object.values({
            ...state.formDataValue.RTI.regsHistoryActions,
            [arrayIndex]: matchRegsHistoryAction(json),
          }),
        },
      },
    };
  },
  // Agencies
  [POST_REGS_TRACK_INT_AGENCY_START]: (state) => {
    return {
      ...state,
    };
  },
  [POST_REGS_TRACK_INT_AGENCY_FAILURE]: (state, action) => {
    return {
      ...state,
      errorCode: action.json,
      isError: true,
    };
  },
  [POST_REGS_TRACK_INT_AGENCY_SUCCESS]: (state, action) => {
    const { json, arrayIndex } = action.payload;

    return {
      ...state,
      formDataValue: {
        ...state.formDataValue,
        RTI: {
          ...state.formDataValue.RTI,
          regsAgencys: Object.values({
            ...state.formDataValue.RTI.regsAgencys,
            [arrayIndex]: matchRegsAgency(json),
          }),
        },
      },
    };
  },
  // Management comments 
  [ADD_REGS_INFO_MANAGMENT_COMMENT_START]: (state) => {
    return {
      ...state,
    };
  },
  [ADD_REGS_INFO_MANAGMENT_COMMENT_FAILURE]: (state, action) => {
    return {
      ...state,
      errorCode: action.json,
      isError: true,
    };
  },
  [ADD_REGS_INFO_MANAGMENT_COMMENT_SUCCESS]: (state, action) => {
    const { json } = action.payload;
    const newManagamentComment = matchManagementComment(json);
    const newManagamentComments = [
      newManagamentComment,
      ...state.formDataValue.RTI.managementComments,
    ];
    return {
      ...state,
      formDataValue: {
        ...state.formDataValue,
        RTI: {
          ...state.formDataValue.RTI,
          managementComments: newManagamentComments,
        },
      },
    };
  },
  [GET_REGS_TRACK_QUERIES_LIST_START]: (state) => {
    return {
      ...state,
      isFetchingData: true,
    };
  },
  [GET_REGS_TRACK_IDS_START]: (state) => {
    return {
      ...state,
    };
  },
  [GET_REGS_TRACK_IDS_FAILURE]: (state, action) => {
    return {
      ...state,
      errorCode: action.json,
      isError: true,
    };
  },
  [GET_REGS_TRACK_BASE_START]: (state) => {
    return {
      ...state,
    };
  },
  [GET_REGS_TRACK_BASE_FAILURE]: (state, action) => {
    return {
      ...state,
      errorCode: action.json,
      isError: true,
    };
  },
  [GET_REGS_TRACK_BASE_SUCCESS]: (state, action) => {
    const clientActions = action.payload.clientActions;
    const recordInfo = action.payload.recordInfo;
    const documents = action.payload.documents;
    const clientSubjectTags = action.payload.clientSubjectTags;
    const managementComments = action.payload.managementComments;
    const standardRemarks = action.payload.standardRemarks;    
    const regsUrls = action.payload.regsUrls;
    const regsCitations = action.payload.regsCitations;
    const stateCitations = action.payload.stateCitations;
    const regsHistoryActions = action.payload.regsHistoryActions;
    const stateHistoryActions = action.payload.stateHistoryActions;
    const regsAgencys = action.payload.regsAgencys;
    const stateAgencys = action.payload.stateAgencys;
    const regsProgress = action.payload.regsProgress;
    const analysts = action.payload.analysts;
    
    return {
      ...state,
      formDataValue: {
        ...state.formDataValue,
        RTI: {
          ...state.formDataValue.RTI,
          recordInfo,
          clientActions,
          documents,
          clientSubjectTags,
          managementComments,
          standardRemarks,
          regsUrls,
          regsCitations,
          stateCitations,
          regsHistoryActions,
          regsHistoryRunRules: true,
          stateHistoryActions,
          regsAgencys,
          stateAgencys,
          regsProgress,
          analysts,
        },
      },
      renderData: {
        ...state.renderData,
        stateHistoryActions,
        stateCitations,
        stateAgencys,
        analysts,
      },
    };
  },

  [GET_REGS_TRACK_CLIENTSUBJECT_START]: (state) => {
    return {
      ...state,
    };
  },
  [GET_REGS_TRACK_CLIENTSUBJECT_FAILURE]: (state, action) => {
    return {
      ...state,
      errorCode: action.json,
      isError: true,
    };
  },
  [GET_REGS_TRACK_CLIENTSUBJECT_SUCCESS]: (state, action) => {
    const clientSubjectTags = action.payload.clientSubjectTags;   
    return {
      ...state,
      formDataValue: {
        ...state.formDataValue,
        RTI: {
          ...state.formDataValue.RTI,
          clientSubjectTags,
        },
      },
      renderData: {
        ...state.renderData,
      },
    };
  },

  [GET_REGS_TRACK_INITIAL_DATA_START]: (state) => {
    return {
      ...state,
      isFetchingData: true,
    };
  },
  [GET_REGS_TRACK_INITIAL_DATA_COMPLETE]: (state) => {
    return {
      ...state,
      isFetchingData: false,
    };
  },
  [REGS_TRACK_INT_OPEN_RECORD_START]: (state) => {
    return {
      ...state,
      isFetchingData: true,
    };
  },
  [OPEN_REGS_TRACK_RECORD_SUCCESS]: (state, action) => {
    const currentIndex = state.renderData.queryRecords.findIndex(
      (record) => record === action.payload.regsId
    );
    return {
      ...state,
      isFetchingData: false,
      lockLoadDate: false,
      formDataValue: {
        ...state.formDataValue,
        RTI: {
          ...state.formDataValue.RTI,
          currentRegsId: action.payload.regsId,
          navigation: {
            ...state.formDataValue.RTI.navigation,
            textValues: {
              ...state.formDataValue.RTI.navigation.textValues,
              currentRecord: currentIndex + 1,
            },
          },
        },
      },
    };
  },
  [SET_REGS_TRACK_ID_REVIEWED_SUCCESS]: (state, action) => {
    const iderInfo = action.payload.json;
    return {
      ...state,
      formDataValue: {
        ...state.formDataValue,
        RTI: {
          ...state.formDataValue.RTI,
          iderReviewedInfo: matchIderInfo(iderInfo),
        },
      },
    };
  },
  [GET_REGS_TRACK_KEYWORDS_SUCCESS]: (state, action) => {
    const keywordHits = action.payload.json;
    return {
      ...state,
      formDataValue: {
        ...state.formDataValue,
        RTI: {
          ...state.formDataValue.RTI,
          recordKeywordHits: matchKeywordHits(keywordHits),
        },
      },
    };
  },
  [GET_REGS_TRACK_CLIENT_SUBJECTS_FAILURE]: (state, action) => {
    return {
      ...state,
      errorCode: action.json,
      isError: true,
    };
  },
  [GET_REGS_TRACK_CLIENT_SUBJECTS_SUCCESS]: (state, action) => {
    const keywordHits = action.payload.json;
    return {
      ...state,
      formDataValue: {
        ...state.formDataValue,
        RTI: {
          ...state.formDataValue.RTI,
          recordClientSubjects: matchClientSubjects(keywordHits),
        },
      },
    };
  },
  [GET_REGS_INFO_HISTORY_LOG_FAILURE]: (state, action) => {
    return {
      ...state,
      errorCode: action.json,
      isError: true,
    };
  },
  [GET_REGS_INFO_HISTORY_LOG_SUCCESS]: (state, action) => {
    const historyLog = action.payload.json;
    return {
      ...state,
      formDataValue: {
        ...state.formDataValue,
        RTI: {
          ...state.formDataValue.RTI,
          textBlocks: {
            ...state.formDataValue.RTI.textBlocks,
            textValues: {
              ...state.formDataValue.RTI.textBlocks.textValues,
              log: matchHistoryLog(historyLog),
            },
          },
        },
      },
    };
  },
  [GET_QC_KEYWORD_MISSING_SUCCESS]: (state, action) => {
    const keywordsMissing = action.payload.json;
    return {
      ...state,
      formDataValue: {
        ...state.formDataValue,
        RTI: {
          ...state.formDataValue.RTI,
          recordQCKeywordMissing: matchQCKeywordMissing(keywordsMissing),
        },
      },
    };
  },
  [GET_QC_KEYWORD_REVIEW_SUCCESS]: (state, action) => {
    const keywordsReview = action.payload.json;
    return {
      ...state,
      formDataValue: {
        ...state.formDataValue,
        RTI: {
          ...state.formDataValue.RTI,
          recordQCKeywordReview: matchQCKeywordReview(keywordsReview),
        },
      },
    };
  },
  [GET_REGS_TRACK_HIGHLIGHTED_DOC_START]: (state) => {
    return {
      ...state,
    };
  },
  [GET_REGS_TRACK_HIGHLIGHTED_DOC_SUCCESS]: (state) => {
    return {
      ...state,
    };
  },
  [GET_REGS_TRACK_HIGHLIGHTED_DOC_FAILURE]: (state, action) => {
    return {
      ...state,
      errorCode: action.json,
      isError: true,
    };
  },
  // [GET_REGS_INFO_HISTORY_START]: (state) => {
  //   return {
  //     ...state,
  //     isFetchingData: true,
  //   };
  // },
  // [GET_REGS_INFO_HISTORY_SUCCESS]: (state, action) => {
  //   const currentRegsProgress = matchBooleansToSelectionList(
  //     action.payload.json
  //   );
  //   return {
  //     ...state,
  //     formDataValue: {
  //       ...state.formDataValue,
  //       RTI: {
  //         ...state.formDataValue.RTI,
  //         currentRegsProgress: currentRegsProgress,
  //       },
  //     },
  //   };
  // },
  // [GET_REGS_INFO_HISTORY_FAILURE]: (state, action) => {
  //   return {
  //     ...state,
  //     errorCode: action.json,
  //     isFetchingData: false,
  //     isError: true,
  //   };
  // },
  [POST_CLIENT_SUBJECT_TAG_SUCCESS]: (state, action) => {
    const clientSubjectTags = matchClientSubjectTags(action.payload.json);

    return {
      ...state,
      formDataValue: {
        ...state.formDataValue,
        RTI: {
          ...state.formDataValue.RTI,
          clientSubjectTags: [
            ...clientSubjectTags,
            ...state.formDataValue.RTI.clientSubjectTags,
          ],
        },
      },
    };
  },
  [POST_CLIENT_SUBJECT_TAG_FAILURE]: (state, action) => {
    return {
      ...state,
      errorCode: action.json,
      isFetchingData: false,
    };
  },
  [GET_REGS_TRACK_SUBJECT_GROUP_LIST_START]: (state) => {
    return {
      ...state,
      formDataValue: {
        ...state.formDataValue,
        RTI: {
          ...state.formDataValue.RTI,
          clientSubjectGroupings: [],
        },
      },
    };
  },
  [GET_REGS_TRACK_SUBJECT_GROUP_LIST_SUCCESS]: (state, action) => {
    const groupingsList = action.payload.json;
    return {
      ...state,
      formDataValue: {
        ...state.formDataValue,
        RTI: {
          ...state.formDataValue.RTI,
          clientSubjectGroupings: groupingsList,
        },
      },
    };
  },
  [GET_REGS_TRACK_SUBJECT_GROUP_LIST_FAILURE]: (state, action) => {
    return {
      ...state,
      errorCode: action.json,
      isFetchingData: false,
      isError: true,
    };
  },
  [GET_REGS_INFO_TAG_COMPARISON_START]: (state) => {
    return {
      ...state,
      formDataValue: {
        ...state.formDataValue,
        RTI: {
          ...state.formDataValue.RTI,
          companionPrimaryTags: {},
        },
      },
    };
  },
  [GET_REGS_INFO_TAG_COMPARISON_SUCCESS]: (state, action) => {
    const companionPrimaryTags = action.payload.json;
    return {
      ...state,
      formDataValue: {
        ...state.formDataValue,
        RTI: {
          ...state.formDataValue.RTI,
          companionPrimaryTags: companionPrimaryTags,
        },
      },
    };
  },
  [GET_REGS_INFO_TAG_COMPARISON_FAILURE]: (state, action) => {
    return {
      ...state,
      errorCode: action.json,
      isFetchingData: false,
      isError: true,
    };
  },
  [SET_QC_KEYWORD_REVIEW_START]: (state) => {
    return {
      ...state,
    };
  },
  [SET_QC_KEYWORD_REVIEW_FAILURE]: (state, action) => {
    return {
      ...state,
      errorCode: action.json,
      isFetchingData: false,
      isError: true,
    };
  },
  [GET_CLIENTS_FAILURE]: (state, action) => {
    return {
      ...state,
      errorCode: action.json,
      isFetchingData: false,
    };
  },
  [GET_CLIENT_SUBJECT_INFO_FAILURE]: (state, action) => {
    return {
      ...state,
      errorCode: action.json,
      isFetchingData: false,
    };
  },
  [GET_GROUPING_FAILURE]: (state, action) => {
    return {
      ...state,
      errorCode: action.json,
      isFetchingData: false,
    };
  },
  [GET_SUBJECTS_FAILURE]: (state, action) => {
    return {
      ...state,
      errorCode: action.json,
      isFetchingData: false,
    };
  },
  [UPLOAD_DOCUMENT_START]: (state) => {
    return {
      ...state,
    };
  },
  [UPLOAD_DOCUMENT_SUCCESS]: (state) => {
    return {
      ...state,
      isFetchingData: false,
    };
  },
  [UPLOAD_DOCUMENT_FAILURE]: (state, action) => {
    return {
      ...state,
      errorCode: action.json,
      isFetchingData: false,
      isError: true,
    };
  },
  [CLEAR_REGS_TRACK_FIELD_FOR_NO_RESULTS]: (state) => {
    const query = state.renderData.queriesWithParameters.find(
      (query) => query.QueryId == state.formDataValue.RTI.queryLine.radio.query
    );

    const {
      parametersSectionSelectables,
      sortParameters,
      sortFields,
      sortDirections,
      filterFields,
    } = populateSortAndSearchParams(query);

    return {
      ...initialState,
      disableEditing: true,
      renderData: {
        ...initialState.renderData,        
        stateCitations: state.renderData.stateCitations,
        stateHistoryActions: state.renderData.stateHistoryActions,
        stateAgencys: state.renderData.stateAgencys,
        queriesWithParameters: state.renderData.queriesWithParameters,
        queries: state.renderData.queries,
        allRegions: state.renderData.allRegions,
        regions: state.renderData.regions,
        regionsList: state.renderData.regionsList,
        regsDocTypes: state.renderData.regsDocTypes,
        nonDeletableDocTypes: state.renderData.nonDeletableDocTypes,      
        analysts: state.renderData.analysts,  
      },
      formDataValue: {
        RTI: {
          ...initialState.formDataValue.RTI,
          queryLine: {
            ...state.formDataValue.RTI.queryLine,
          },
          parametersSection: {
            ...state.formDataValue.RTI.parametersSection,
            radio: parametersSectionSelectables,
          },
          sortParameters: {
            radio: sortParameters,
            fields: sortFields,
          },
          sortDirections: {
            radio: sortDirections,
          },
          filterParameters: {
            fields: filterFields,
          },
        },
      },
    };
  },
};
// ------------------------------------
// Reducer
// ------------------------------------
const initialState = {
  errorCode: "",
  isFetchingData: false,
  lockLoadDate: false,  
  renderData: {
    queryRecords: [],
    queryProperties: [],
    currentRecord: {},
    recordIndex: 0,    
    stateCitations: [],
    stateHistoryActions: [],
    stateAgencys: [],
    regsTypes: regulationConstants.regulationTypeValues,
    analysts: [],
  },
  formDataValue: {
    RTI: {
      settingsLine: {
        radio: {
          autoAdvance: true,
          autoUrl: false,
          extraInfoExpanded: false,
          clientActionsExpanded: false,
        },
      },
      queryLine: {
        radio: {
          query: "Select Query",
        },
        textValues: {
          keywordSearch: "",
        },
        selected: [],
      },
      parametersSection: {
        textValues: {},
        dateTime: {},
        radio: [],
      },
      sortParameters: {
        radio: [],
        fields: [],
      },
      sortDirections: {
        radio: [],
      },
      filterParameters: {
        fields: [],
      },
      navigation: {
        textValues: {
          currentRecord: "1",
        },
      },
      //currentRegsProgress: matchBooleansToSelectionList([]),
      reviewRecords: matchReviewRows([]),
      recordInfo: matchRecordInfo(
        {},
        matchBaseRecordInfo({ LoadDate: new Date("1/1/1901") })
      ),
      iderReviewedInfo: matchIderInfo({}),
      recordKeywordHits: matchKeywordHits([]),
      recordClientSubjects: matchClientSubjects([]),
      recordQCKeywordMissing: matchQCKeywordMissing([]),
      recordQCKeywordReview: matchQCKeywordReview([]),
      documents: matchDocuments([]),
      clientActions: matchClientActions([]),
      regsUrls: matchRegsUrls([]),
      regsCitations: matchRegsCitations([]),
      stateCitations: matchStateCitationOptions([]),
      regsHistoryActions: matchHistoryActions([]),
      regsHistoryRunRules: false,
      stateHistoryActions: matchStateHistoryActionOptions([]),
      regsAgencys: matchRegsAgencys([]),
      stateAgencys: matchStateAgencyOptions([]),
      regsProgress: matchRegsHistory([]),
      analysts: matchAnalystOptions([]),
      clientSubjectTags: [],
      clientSubjectGroupings: [],
      managementComments: [],      
      standardRemarks: [],
      otherDocs: {
        0: {
          textValues: {
            urlIdDocs: "",
            urlDescription: "",
          },
          radio: {
            docsType: "versions",
          },
        },
      },
      clients: {
        selected: [],
      },
      notLoadedClients: {
        selected: [],
      },
      history: {
        textValues: {
          history: "",
        },
      },
      textBlocks: {
        textValues: {
          log: [],
        },
      },
    },
  },
};

function clientActionSuccess(action, state) {
  const updatedClientAction = action.payload.json;
  const clientActionIndex = state.formDataValue.RTI.clientActions.findIndex(
    (clientAction) =>
      clientAction.textValues.clientActionId ===
      updatedClientAction.ClientActionId
  );

  return {
    ...state,
    formDataValue: {
      ...state.formDataValue,
      RTI: {
        ...state.formDataValue.RTI,
        clientActions: Object.values({
          ...state.formDataValue.RTI.clientActions,
          [clientActionIndex]: matchClientAction(updatedClientAction),
        }),
      },
    },
  };
}

export default function regsTrackInternalReducer(
  state = initialState,
  action
) {
  const handler = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}



// WEBPACK FOOTER //
// ./src/store/reducers/regsTrackInternalFormData.js